export const icons = {
  access_time: {
    name: 'access_time',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
      },
      {
        windingRule: 'nonzero',
        data: 'M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  account_balance_wallet: {
    name: 'account_balance_wallet',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  account_circle: {
    name: 'account_circle',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  add: {
    name: 'add',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  add_alert: {
    name: 'add_alert',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM13 8h-2v3H8v2h3v3h2v-3h3v-2h-3z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  add_circle: {
    name: 'add_circle',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  add_shopping_cart: {
    name: 'add_shopping_cart',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  alarm: {
    name: 'alarm',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z',
      },
    ],
    size: {
      width: 26,
      height: 26,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  alarm_on: {
    name: 'alarm_on',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  alarm_off: {
    name: 'alarm_off',
    paths: [
      {
        windingRule: 'nonzero',
        data: '',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  alternate_email: {
    name: 'alternate_email',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 1.95c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  archive: {
    name: 'archive',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM5 19V8h14v11H5zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  arrow_back: {
    name: 'arrow_back',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  arrow_drop_down: {
    name: 'arrow_drop_down',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M7 10l5 5 5-5H7z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  arrow_forward: {
    name: 'arrow_forward',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  assessment: {
    name: 'assessment',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  assignment: {
    name: 'assignment',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  assignment_ind: {
    name: 'assignment_ind',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.22 0 .41.1.55.25.12.13.2.31.2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.19.08-.37.2-.5.14-.15.33-.25.55-.25zM19 19H5V5h14v14zM12 6c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-6 6.47V18h12v-1.53c0-2.5-3.97-3.58-6-3.58s-6 1.07-6 3.58zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  block: {
    name: 'block',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  build: {
    name: 'build',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31 1.08 1.08 1.49 2.57 1.24 3.96-.12.71-.42 1.37-.88 1.96l9.45 9.45-.88.89z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  cancel: {
    name: 'cancel',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  check: {
    name: 'check',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  check_circle: {
    name: 'check_circle',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  check_circle_filled: {
    name: 'check_circle_filled',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  clear: {
    name: 'clear',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  cloud_upload: {
    name: 'cloud_upload',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  cloud_download: {
    name: 'cloud_download',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M24.1875 12.55C23.3375 8.2375 19.55 5 15 5C11.3875 5 8.25 7.05 6.6875 10.05C2.925 10.45 0 13.6375 0 17.5C0 21.6375 3.3625 25 7.5 25H23.75C27.2 25 30 22.2 30 18.75C30 15.45 27.4375 12.775 24.1875 12.55ZM23.75 22.5H7.5C4.7375 22.5 2.5 20.2625 2.5 17.5C2.5 14.9375 4.4125 12.8 6.95 12.5375L8.2875 12.4L8.9125 11.2125C10.1 8.925 12.425 7.5 15 7.5C18.275 7.5 21.1 9.825 21.7375 13.0375L22.1125 14.9125L24.025 15.05C25.975 15.175 27.5 16.8125 27.5 18.75C27.5 20.8125 25.8125 22.5 23.75 22.5ZM13.1875 12.5H16.8125V16.25H20L15 21.25L10 16.25H13.1875V12.5Z',
      },
    ],
    size: {
      width: 30,
      height: 30,
    },
    viewBox: '0 0 30 30',
    translate: {
      x: 0,
      y: 0,
    },
  },
  close: {
    name: 'close',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  credit_card: {
    name: 'credit_card',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  dashboard: {
    name: 'dashboard',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  delete: {
    name: 'delete',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  delete_forever: {
    name: 'delete_forever',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  description: {
    name: 'description',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  document_scanner: {
    name: 'document_scanner',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M7 3H4V6H2V1H7V3ZM22 6V1H17V3H20V6H22ZM7 21H4V18H2V23H7V21ZM20 18V21H17V23H22V18H20ZM17 6H7V18H17V6ZM19 18C19 19.1 18.1 20 17 20H7C5.9 20 5 19.1 5 18V6C5 4.9 5.9 4 7 4H17C18.1 4 19 4.9 19 6V18ZM15 8H9V10H15V8ZM15 11H9V13H15V11ZM15 14H9V16H15V14Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  done: {
    name: 'done',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  done_all: {
    name: 'done_all',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  edit: {
    name: 'edit',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  email: {
    name: 'email',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  error: {
    name: 'error',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  error_filled: {
    name: 'error_filled',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  extension: {
    name: 'extension',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M10.5 4.5c.28 0 .5.22.5.5v2h6v6h2c.28 0 .5.22.5.5s-.22.5-.5.5h-2v6h-2.12c-.68-1.75-2.39-3-4.38-3s-3.7 1.25-4.38 3H4v-2.12c1.75-.68 3-2.39 3-4.38 0-1.99-1.24-3.7-2.99-4.38L4 7h6V5c0-.28.22-.5.5-.5m0-2C9.12 2.5 8 3.62 8 5H4c-1.1 0-1.99.9-1.99 2v3.8h.29c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-.3c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7v.3H17c1.1 0 2-.9 2-2v-4c1.38 0 2.5-1.12 2.5-2.5S20.38 11 19 11V7c0-1.1-.9-2-2-2h-4c0-1.38-1.12-2.5-2.5-2.5z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  favorite: {
    name: 'favorite',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  filter_list: {
    name: 'filter_list',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  filter_none: {
    name: 'filter_none',
    paths: [
      {
        fill: '#575481',
        windingRule: 'nonzero',
        data:
          'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  forward: {
    name: 'forward',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M14 8.83L17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  forward_to_inbox: {
    name: 'forward_to_inbox',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h9v-2H4V8l8,5l8-5v5h2V6C22,4.9,21.1,4,20,4z M12,11L4,6h16L12,11z M19,15l4,4 l-4,4v-3h-4v-2h4V15z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  help: {
    name: 'help',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  history: {
    name: 'history',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  expenses: {
    name: 'expenses',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M48.7937 22.1984C54.9532 22.1984 59.9465 17.2291 59.9465 11.0992C59.9465 4.96928 54.9532 0 48.7937 0C42.6342 0 37.6409 4.96928 37.6409 11.0992C37.6409 17.2291 42.6342 22.1984 48.7937 22.1984Z\n' +
          'M48.7937 59.9999C54.9532 59.9999 59.9465 55.0307 59.9465 48.9007C59.9465 42.7708 54.9532 37.8015 48.7937 37.8015C42.6342 37.8015 37.6409 42.7708 37.6409 48.9007C37.6409 55.0307 42.6342 59.9999 48.7937 59.9999Z\n' +
          'M11.1528 59.9999C17.3123 59.9999 22.3056 55.0307 22.3056 48.9007C22.3056 42.7708 17.3123 37.8015 11.1528 37.8015C4.99328 37.8015 0 42.7708 0 48.9007C0 55.0307 4.99328 59.9999 11.1528 59.9999Z\n' +
          'M11.1528 22.1984C17.3123 22.1984 22.3056 17.2291 22.3056 11.0992C22.3056 4.96928 17.3123 0 11.1528 0C4.99328 0 0 4.96928 0 11.0992C0 17.2291 4.99328 22.1984 11.1528 22.1984Z',
      },
    ],
    size: {
      width: 6,
      height: 6,
    },
    viewBox: '-12 -12 84 84',
    translate: {
      x: 0,
      y: 0,
    },
  },
  suppliers: {
    name: 'suppliers',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  how_to_reg: {
    name: 'how_to_reg',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M9 17l3-2.94c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4',
      },
      {
        windingRule: 'nonzero',
        data: 'M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  image: {
    name: 'image',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  info: {
    name: 'info',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  info_outlined: {
    name: 'info_outlined',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  keyboard: {
    name: 'keyboard',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20 7v10H4V7h16m0-2H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-3 0h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  keyboard_arrow_down: {
    name: 'kayboard_arrow_down',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  keyboard_arrow_left: {
    name: 'kayboard_arrow_left',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  keyboard_arrow_right: {
    name: 'keyboard_arrow_right',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  keyboard_arrow_up: {
    name: 'kayboard_arrow_up',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  keyboard_backspace: {
    name: 'keyboard_backspace',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  label: {
    name: 'label',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  launch: {
    name: 'launch',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  link_off: {
    name: 'link_off',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4C21.05 15.36 22 13.79 22 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  local_atm: {
    name: 'local_atm',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  local_offer: {
    name: 'local_offer',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M21.41 11.58L12.41 2.58002C12.05 2.21997 11.55 2 11 2H4C2.90002 2 2 2.90002 2 4V11C2 11.55 2.21997 12.05 2.59003 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.98999L20 12.99L13 20.01ZM5 6.5C5 5.67157 5.67157 5 6.5 5C7.32843 5 8 5.67157 8 6.5C8 7.32843 7.32843 8 6.5 8C5.67157 8 5 7.32843 5 6.5Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  lock: {
    name: 'lock',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  loyalty: {
    name: 'loyalty',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  mail_outline: {
    name: 'mail_outline',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  menu: {
    name: 'menu',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  menu_book: {
    name: 'menu_book',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M21,5c-1.11-0.35-2.33-0.5-3.5-0.5c-1.95,0-4.05,0.4-5.5,1.5c-1.45-1.1-3.55-1.5-5.5-1.5S2.45,4.9,1,6v14.65 c0,0.25,0.25,0.5,0.5,0.5c0.1,0,0.15-0.05,0.25-0.05C3.1,20.45,5.05,20,6.5,20c1.95,0,4.05,0.4,5.5,1.5c1.35-0.85,3.8-1.5,5.5-1.5 c1.65,0,3.35,0.3,4.75,1.05c0.1,0.05,0.15,0.05,0.25,0.05c0.25,0,0.5-0.25,0.5-0.5V6C22.4,5.55,21.75,5.25,21,5z M21,18.5 c-1.1-0.35-2.3-0.5-3.5-0.5c-1.7,0-4.15,0.65-5.5,1.5V8c1.35-0.85,3.8-1.5,5.5-1.5c1.2,0,2.4,0.15,3.5,0.5V18.5z',
      },
      {
        windingRule: 'nonzero',
        data:
          'M17.5,10.5c0.88,0,1.73,0.09,2.5,0.26V9.24C19.21,9.09,18.36,9,17.5,9c-1.7,0-3.24,0.29-4.5,0.83v1.66 C14.13,10.85,15.7,10.5,17.5,10.5z',
      },
      {
        windingRule: 'nonzero',
        data:
          'M13,12.49v1.66c1.13-0.64,2.7-0.99,4.5-0.99c0.88,0,1.73,0.09,2.5,0.26V11.9c-0.79-0.15-1.64-0.24-2.5-0.24 C15.8,11.66,14.26,11.96,13,12.49z',
      },
      {
        windingRule: 'nonzero',
        data:
          'M17.5,14.33c-1.7,0-3.24,0.29-4.5,0.83v1.66c1.13-0.64,2.7-0.99,4.5-0.99c0.88,0,1.73,0.09,2.5,0.26v-1.52 C19.21,14.41,18.36,14.33,17.5,14.33z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  monetization_on: {
    name: 'monetization_on',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  money_off: {
    name: 'money_off',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  more_vert: {
    name: 'more_vert',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  more_horiz: {
    name: 'more_horiz',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  notification_important: {
    name: 'notification_important',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM11 8h2v4h-2zm0 6h2v2h-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  notifications_active: {
    name: 'notifications_active',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  open_in_new: {
    name: 'open_in_new',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  payment: {
    name: 'payment',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  priority_high: {
    name: 'priority_high',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M14 3H10V15H14V3ZM10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  question_answer: {
    name: 'question_answer',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  receipt: {
    name: 'receipt',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  remove: {
    name: 'remove',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M19 13H5v-2h14v2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  remove_shopping_cart: {
    name: 'remove_shopping_cart',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7zM20 4H7.12l2 2h9.19l-2.76 5h-1.44l1.94 1.94c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  save_alt: {
    name: 'save_alt',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  search: {
    name: 'search',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  settings: {
    name: 'settings',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  settings_ethernet: {
    name: 'settings_ethernet',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  settings_outlined: {
    name: 'settings_outlined',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  shopping_cart: {
    name: 'shopping_cart',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  social: {
    name: 'social',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M12 2C6.47998 2 2 6.47998 2 12C2 17.52 6.47998 22 12 22C17.52 22 22 17.52 22 12C22 6.47998 17.52 2 12 2ZM4 12C4 11.39 4.07996 10.79 4.20996 10.22L8.98999 15V16C8.98999 17.1 9.89001 18 10.99 18V19.93C7.06006 19.43 4 16.0699 4 12ZM15.99 16C16.89 16 17.63 16.59 17.89 17.4C19.1899 15.98 20 14.08 20 12C20 8.65002 17.92 5.77002 14.99 4.59003V5C14.99 6.10004 14.09 7 12.99 7H10.99V9C10.99 9.55005 10.54 10 9.98999 10H7.98999V12H13.99C14.54 12 14.99 12.45 14.99 13V16H15.99Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  speed: {
    name: 'speed',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20.38 8.57l-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44z',
      },
      {
        windingRule: 'nonzero',
        data: 'M10.59 15.41a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  store: {
    name: 'store',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  supervisor_account: {
    name: 'supervisor_account',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm.05 10H4.77c.99-.5 2.7-1 4.23-1 .11 0 .23.01.34.01.34-.73.93-1.33 1.64-1.81-.73-.13-1.42-.2-1.98-.2-2.34 0-7 1.17-7 3.5V19h7v-1.5c0-.17.02-.34.05-.5zm7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm1.21-1.82c.76-.43 1.29-1.24 1.29-2.18C19 9.12 17.88 8 16.5 8S14 9.12 14 10.5c0 .94.53 1.75 1.29 2.18.36.2.77.32 1.21.32s.85-.12 1.21-.32z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  sync: {
    name: 'sync',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  sync_alt: {
    name: 'sync_alt',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  link: {
    name: 'link',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  sync_problem: {
    name: 'sync_problem',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  timer_off: {
    name: 'timer_off',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  touch_app: {
    name: 'touch_app',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M18.19,12.44l-3.24-1.62c1.29-1,2.12-2.56,2.12-4.32c0-3.03-2.47-5.5-5.5-5.5s-5.5,2.47-5.5,5.5c0,2.13,1.22,3.98,3,4.89 v3.26c-2.15-0.46-2.02-0.44-2.26-0.44c-0.53,0-1.03,0.21-1.41,0.59L4,16.22l5.09,5.09C9.52,21.75,10.12,22,10.74,22h6.3 c0.98,0,1.81-0.7,1.97-1.67l0.8-4.71C20.03,14.32,19.38,13.04,18.19,12.44z M17.84,15.29L17.04,20h-6.3 c-0.09,0-0.17-0.04-0.24-0.1l-3.68-3.68l4.25,0.89V6.5c0-0.28,0.22-0.5,0.5-0.5c0.28,0,0.5,0.22,0.5,0.5v6h1.76l3.46,1.73 C17.69,14.43,17.91,14.86,17.84,15.29z M8.07,6.5c0-1.93,1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5c0,0.95-0.38,1.81-1,2.44V6.5 c0-1.38-1.12-2.5-2.5-2.5c-1.38,0-2.5,1.12-2.5,2.5v2.44C8.45,8.31,8.07,7.45,8.07,6.5z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  unarchive: {
    name: 'unarchive',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM5 19V8h14v11H5zm3-5h2.55v3h2.9v-3H16l-4-4z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  undo: {
    name: 'undo',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  unpublished: {
    name: 'unpublished',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M7.94,5.12L6.49,3.66C8.07,2.61,9.96,2,12,2c5.52,0,10,4.48,10,10c0,2.04-0.61,3.93-1.66,5.51l-1.46-1.46 C19.59,14.86,20,13.48,20,12c0-4.41-3.59-8-8-8C10.52,4,9.14,4.41,7.94,5.12z M17.66,9.53l-1.41-1.41l-2.65,2.65l1.41,1.41 L17.66,9.53z M19.78,22.61l-2.27-2.27C15.93,21.39,14.04,22,12,22C6.48,22,2,17.52,2,12c0-2.04,0.61-3.93,1.66-5.51L1.39,4.22 l1.41-1.41l18.38,18.38L19.78,22.61z M16.06,18.88l-3.88-3.88l-1.59,1.59l-4.24-4.24l1.41-1.41l2.83,2.83l0.18-0.18L5.12,7.94 C4.41,9.14,4,10.52,4,12c0,4.41,3.59,8,8,8C13.48,20,14.86,19.59,16.06,18.88z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  verified_user: {
    name: 'verified_user',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  view_list: {
    name: 'view_list',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },

  visibility: {
    name: 'visibility',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  visibility_filled: {
    name: 'visibility_filled',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  visibility_off: {
    name: 'visibility_off',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M4.68994 6.52496L2.01001 3.84497L3.42004 2.42499L21.15 20.165L19.74 21.575L16.3199 18.155C14.98 18.685 13.52 18.975 12 18.975C7 18.975 2.72998 15.865 1 11.475C1.77002 9.505 3.06006 7.80499 4.68994 6.52496ZM12 5.97498C15.79 5.97498 19.17 8.10498 20.8199 11.475C20.23 12.6949 19.4 13.745 18.41 14.595L19.8199 16.005C21.21 14.775 22.3099 13.235 23 11.475C21.27 7.08496 17 3.97498 12 3.97498C10.73 3.97498 9.51001 4.17499 8.35999 4.54498L10.01 6.19495C10.66 6.065 11.3199 5.97498 12 5.97498ZM10.9301 7.11499L13 9.185C13.5701 9.435 14.03 9.89496 14.28 10.465L16.3501 12.535C16.4301 12.1949 16.4901 11.835 16.4901 11.465C16.5 8.98499 14.4801 6.97498 12 6.97498C11.63 6.97498 11.28 7.02496 10.9301 7.11499ZM9.51001 11.345L12.12 13.955C12.08 13.965 12.04 13.975 12 13.975C10.62 13.975 9.5 12.855 9.5 11.475C9.5 11.45 9.50244 11.43 9.505 11.41C9.50757 11.39 9.51001 11.37 9.51001 11.345ZM7.86011 9.69501L6.11011 7.94501C4.90002 8.86499 3.88 10.045 3.18005 11.475C4.83008 14.845 8.21008 16.975 12 16.975C12.9501 16.975 13.87 16.835 14.75 16.595L13.77 15.615C13.2301 15.845 12.63 15.975 12 15.975C9.52002 15.975 7.5 13.955 7.5 11.475C7.5 10.845 7.63 10.245 7.86011 9.69501Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  visibility_off_filled: {
    name: 'visibility_off_filled',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },

  zoom_out_map: {
    name: 'zoom_out_map',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M5.3 6.7L3 9V3H9L6.7 5.3L9.59 8.17L8.17 9.59L5.3 6.7ZM17.3 5.3L15 3H21V9L18.7 6.7L15.83 9.59L14.41 8.17L17.3 5.3ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM18.7 17.3L21 15V21H15L17.3 18.7L14.41 15.83L15.83 14.41L18.7 17.3Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  zoom_in: {
    name: 'zoom_in',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M15.755 14.255H14.965L14.685 13.985C15.665 12.845 16.255 11.365 16.255 9.755C16.255 6.165 13.345 3.255 9.755 3.255C6.165 3.255 3.255 6.165 3.255 9.755C3.255 13.345 6.165 16.255 9.755 16.255C11.365 16.255 12.845 15.665 13.985 14.685L14.255 14.965V15.755L19.255 20.745L20.745 19.255L15.755 14.255ZM9.755 14.255C7.26501 14.255 5.255 12.245 5.255 9.755C5.255 7.26501 7.26501 5.255 9.755 5.255C12.245 5.255 14.255 7.26501 14.255 9.755C14.255 12.245 12.245 14.255 9.755 14.255ZM9.255 9.255V7.255H10.255V9.255H12.255V10.255H10.255V12.255H9.255V10.255H7.255V9.255H9.255Z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  bug_report: {
    name: 'bug_report',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65C8.03 15.48 8 15.23 8 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18c.31-.08.63-.12.94-.12.32 0 .63.04.95.12l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  emoji_events: {
    name: 'emoji_events',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M19,5h-2V3H7v2H5C3.9,5,3,5.9,3,7v1c0,2.55,1.92,4.63,4.39,4.94c0.63,1.5,1.98,2.63,3.61,2.96V19H7v2h10v-2h-4v-3.1 c1.63-0.33,2.98-1.46,3.61-2.96C19.08,12.63,21,10.55,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.82C5.84,10.4,5,9.3,5,8z M12,14 c-1.65,0-3-1.35-3-3V5h6v6C15,12.65,13.65,14,12,14z M19,8c0,1.3-0.84,2.4-2,2.82V7h2V8z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  expand_more: {
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  expand_less: {
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M6.41 15.41L12 9.83l5.59 5.58L18 14l-6-6-6 6z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  schedule_send: {
    name: 'schedule_send',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M17,12c-2.76,0-5,2.24-5,5s2.24,5,5,5c2.76,0,5-2.24,5-5S19.76,12,17,12z M18.65,19.35l-2.15-2.15V14h1v2.79l1.85,1.85 L18.65,19.35z',
      },
      {
        windingRule: 'nonzero',
        data:
          'M11,12l-6-1.5V7.01l8.87,3.74c0.94-0.47,2-0.75,3.13-0.75c0.1,0,0.19,0.01,0.28,0.01L3,4v16l7-2.95c0-0.02,0-0.03,0-0.05 c0-0.8,0.14-1.56,0.39-2.28L5,16.99V13.5L11,12z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  event_available: {
    name: 'event_available',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  redeem: {
    name: 'redeem',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  perm_identity: {
    name: 'perm_identity',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 9c2.7 0 5.8 1.29 6 2v1H6v-.99c.2-.72 3.3-2.01 6-2.01m0-11C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z',
      },
    ],
    size: {
      width: 24,
      height: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  secure: {
    name: 'secure',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M12 0L0 4.5V13.635C0 21.21 5.115 28.275 12 30C18.885 28.275 24 21.21 24 13.635V4.5L12 0ZM21 13.635C21 19.635 17.175 25.185 12 26.88C6.825 25.185 3 19.65 3 13.635V6.465L12 3.285L21 6.465V13.635ZM7.23 12.885L5.1 15L10.41 20.31L18.9 11.82L16.785 9.705L10.425 16.065L7.23 12.885Z',
      },
    ],
    size: {
      height: 30,
      width: 24,
    },
    viewBox: '0 0 24 30',
    fill: '#009D4E',
  },
  dollar: {
    name: 'dollar',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  smartphone: {
    name: 'smartphone',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  arrow_right_down: {
    name: 'arrow_right_down',
    paths: [
      {
        windingRule: 'nonzero',
        data:
          'M6.5 7.79289V2C6.5 1.17157 5.82843 0.5 5 0.5H1C0.723857 0.5 0.5 0.723857 0.5 1C0.5 1.27614 0.723857 1.5 1 1.5L5 1.5C5.27614 1.5 5.5 1.72386 5.5 2V7.79289L3.35355 5.64645C3.15829 5.45118 2.84171 5.45118 2.64645 5.64645C2.45118 5.84171 2.45118 6.15829 2.64645 6.35355L5.64645 9.35355C5.84171 9.54882 6.15829 9.54882 6.35355 9.35355L9.35355 6.35355C9.54882 6.15829 9.54882 5.84171 9.35355 5.64645C9.15829 5.45118 8.84171 5.45118 8.64645 5.64645L6.5 7.79289Z',
      },
    ],
    size: {
      height: 16,
      width: 10,
    },
    viewBox: '0 0 10 10',
    translate: {
      x: 0,
      y: 0,
    },
  },
  library_add: {
    name: 'library_add',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M4.5 0.5H13.5C14.325 0.5 15 1.175 15 2V11C15 11.825 14.325 12.5 13.5 12.5H4.5C3.675 12.5 3 11.825 3 11V2C3 1.175 3.675 0.5 4.5 0.5ZM0 3.5H1.5V14H12V15.5H1.5C0.675 15.5 0 14.825 0 14V3.5ZM13.5 11H4.5V2H13.5V11ZM9.75 9.5H8.25V7.25H6V5.75H8.25V3.5H9.75V5.75H12V7.25H9.75V9.5Z',
      },
    ],
    size: {
      height: 14,
      width: 13,
    },
    viewBox: '0 0 15 16',
    translate: {
      x: 0,
      y: 0,
    },
  },

  history_24: {
    name: 'history_24',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M3.875 9C3.875 5.2725 6.8975 2.25 10.625 2.25C14.3525 2.25 17.375 5.2725 17.375 9C17.375 12.7275 14.3525 15.75 10.625 15.75C8.7575 15.75 7.0775 14.9925 5.855 13.77L6.92 12.705C7.865 13.6575 9.1775 14.25 10.625 14.25C13.5275 14.25 15.875 11.9025 15.875 9C15.875 6.0975 13.5275 3.75 10.625 3.75C7.7225 3.75 5.375 6.0975 5.375 9H7.625L4.595 12.0225L4.5425 11.9175L1.625 9H3.875ZM9.875 9.75V6H11V9.1125L13.64 10.68L13.0625 11.64L9.875 9.75Z',
      },
    ],
    size: {
      height: 18,
      width: 19,
    },
    viewBox: '0 0 19 18',
    translate: {
      x: 0,
      y: 0,
    },
  },
  how_to_reg_24: {
    name: 'how_to_reg_24',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M12.584 6.45833C12.584 8.3 11.0923 9.79167 9.25065 9.79167C7.40898 9.79167 5.91732 8.3 5.91732 6.45833C5.91732 4.61667 7.40898 3.125 9.25065 3.125C11.0923 3.125 12.584 4.61667 12.584 6.45833ZM10.9173 6.45833C10.9173 5.54167 10.1673 4.79167 9.25065 4.79167C8.33398 4.79167 7.58398 5.54167 7.58398 6.45833C7.58398 7.375 8.33398 8.125 9.25065 8.125C10.1673 8.125 10.9173 7.375 10.9173 6.45833ZM4.25065 14.7917C4.41732 14.2667 6.39232 13.3917 8.38398 13.175L10.084 11.5083C9.75898 11.475 9.51732 11.4583 9.25065 11.4583C7.02565 11.4583 2.58398 12.575 2.58398 14.7917V16.4583H10.084L8.41732 14.7917H4.25065ZM12.9757 14.5167L17.2507 10.2083L18.4173 11.3833L12.9757 16.875L10.084 13.9583L11.2507 12.7833L12.9757 14.5167Z',
      },
    ],
    size: {
      height: 20,
      width: 21,
    },
    viewBox: '0 0 21 20',
    translate: {
      x: 0,
      y: 0,
    },
  },
  calendar: {
    name: 'calendar',
    paths: [
      {
        windingRule: 'nonzero',
        data: 'M7.22646 4.45288H48.3715C52.3601 4.45288 55.598 7.69079 55.598 11.6793V13.4542H0V11.6793C0 7.69079 3.23791 4.45288 7.22646 4.45288Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M51.5835 59.0204C59.3583 59.0204 65.6611 52.5581 65.6611 44.5865C65.6611 36.615 59.3583 30.1527 51.5835 30.1527C43.8086 30.1527 37.5059 36.615 37.5059 44.5865C37.5059 52.5581 43.8086 59.0204 51.5835 59.0204Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M42.3537 32.9898L38.346 37.8435L36.2023 44.8346L37.4491 51.4186L4.69464 51.4886C2.60813 51.4886 0.916016 49.8028 0.916016 47.7163V14.4784H55.5916V29.1667L47.7608 29.3512L42.3537 32.9898Z',
        fill: 'white',
      },
      {
        windingRule: 'nonzero',
        data: 'M55.5471 15.5026H1.02417C0.458015 15.5026 0 15.0446 0 14.4784C0 13.9122 0.458015 13.4542 1.02417 13.4542H55.5471C56.1132 13.4542 56.5712 13.9122 56.5712 14.4784C56.5712 15.0446 56.1132 15.5026 55.5471 15.5026Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M6.323 10.2354C5.75684 10.2354 5.29883 9.77735 5.29883 9.21119V1.02417C5.29883 0.458015 5.75684 0 6.323 0C6.88916 0 7.34717 0.458015 7.34717 1.02417V9.20483C7.34717 9.77099 6.88916 10.229 6.323 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M9.77808 10.2354C9.21192 10.2354 8.75391 9.77735 8.75391 9.21119V1.02417C8.75391 0.458015 9.21192 0 9.77808 0C10.3442 0 10.8023 0.458015 10.8023 1.02417V9.20483C10.8023 9.77099 10.3442 10.229 9.77808 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M19.6433 10.2354C19.0772 10.2354 18.6191 9.77735 18.6191 9.21119V1.02417C18.6191 0.458015 19.0772 0 19.6433 0C20.2095 0 20.6675 0.458015 20.6675 1.02417V9.20483C20.6675 9.77099 20.2095 10.229 19.6433 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M23.0984 10.2354C22.5322 10.2354 22.0742 9.77735 22.0742 9.21119V1.02417C22.0742 0.458015 22.5322 0 23.0984 0C23.6646 0 24.1226 0.458015 24.1226 1.02417V9.20483C24.1226 9.77099 23.6646 10.229 23.0984 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M32.9636 10.2354C32.3975 10.2354 31.9395 9.77735 31.9395 9.21119V1.02417C31.9395 0.458015 32.3975 0 32.9636 0C33.5298 0 33.9878 0.458015 33.9878 1.02417V9.20483C33.9878 9.77099 33.5298 10.229 32.9636 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M36.4128 10.2354C35.8467 10.2354 35.3887 9.77735 35.3887 9.21119V1.02417C35.3887 0.458015 35.8467 0 36.4128 0C36.979 0 37.437 0.458015 37.437 1.02417V9.20483C37.437 9.77099 36.979 10.229 36.4128 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M46.2781 10.2354C45.7119 10.2354 45.2539 9.77735 45.2539 9.21119V1.02417C45.2539 0.458015 45.7119 0 46.2781 0C46.8442 0 47.3023 0.458015 47.3023 1.02417V9.20483C47.3023 9.77099 46.8442 10.229 46.2781 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M49.7332 10.2354C49.167 10.2354 48.709 9.77735 48.709 9.21119V1.02417C48.709 0.458015 49.167 0 49.7332 0C50.2993 0 50.7573 0.458015 50.7573 1.02417V9.20483C50.7573 9.77099 50.2993 10.229 49.7332 10.229V10.2354Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M51.5831 60.0001C42.7854 60.0001 35.6289 52.8436 35.6289 44.0459C35.6289 35.2481 42.7854 28.098 51.5831 28.098C60.3808 28.098 67.5373 35.2545 67.5373 44.0459C67.5373 52.8372 60.3808 60.0001 51.5831 60.0001ZM51.5831 30.1527C43.9177 30.1527 37.6836 36.3868 37.6836 44.0522C37.6836 51.7176 43.9177 57.9517 51.5831 57.9517C59.2485 57.9517 65.4826 51.7176 65.4826 44.0522C65.4826 36.3868 59.2485 30.1527 51.5831 30.1527Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M19.6445 6.50757H9.77808C9.21192 6.50757 8.75391 6.04956 8.75391 5.4834C8.75391 4.91724 9.21192 4.45923 9.77808 4.45923H19.6445C20.2106 4.45923 20.6687 4.91724 20.6687 5.4834C20.6687 6.04956 20.2106 6.50757 19.6445 6.50757Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M32.9648 6.50757H23.0984C22.5322 6.50757 22.0742 6.04956 22.0742 5.4834C22.0742 4.91724 22.5322 4.45923 23.0984 4.45923H32.9648C33.531 4.45923 33.989 4.91724 33.989 5.4834C33.989 6.04956 33.531 6.50757 32.9648 6.50757Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M46.2793 6.50757H36.4128C35.8467 6.50757 35.3887 6.04956 35.3887 5.4834C35.3887 4.91724 35.8467 4.45923 36.4128 4.45923H46.2793C46.8454 4.45923 47.3034 4.91724 47.3034 5.4834C47.3034 6.04956 46.8454 6.50757 46.2793 6.50757Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M37.6275 35.3563C39.2858 35.3563 40.6301 34.012 40.6301 32.3537C40.6301 30.6955 39.2858 29.3512 37.6275 29.3512C35.9693 29.3512 34.625 30.6955 34.625 32.3537C34.625 34.012 35.9693 35.3563 37.6275 35.3563Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M38.5305 52.3028H5.80153C2.60178 52.3028 0 49.701 0 46.5012V10.2544C0 7.05466 2.60178 4.45288 5.80153 4.45288H6.32316C6.88931 4.45288 7.34733 4.9109 7.34733 5.47705C7.34733 6.04321 6.88931 6.50123 6.32316 6.50123H5.80153C3.7341 6.50123 2.05471 8.18062 2.05471 10.248V46.4949C2.05471 48.5623 3.7341 50.2417 5.80153 50.2417H36.8893C36.0623 48.2888 35.6361 46.1704 35.6361 44.0394C35.6361 35.2417 42.7926 28.0916 51.5903 28.0916C52.5763 28.0916 53.5623 28.1806 54.5293 28.3651V10.2544C54.5293 8.18698 52.8499 6.50759 50.7824 6.50759H49.7455C49.1794 6.50759 48.7214 6.04957 48.7214 5.48342C48.7214 4.91726 49.1794 4.45924 49.7455 4.45924H50.7824C53.9822 4.45924 56.584 7.06102 56.584 10.2608V29.6692C56.584 29.9872 56.4313 30.2926 56.1768 30.4834C55.9224 30.6743 55.5916 30.7442 55.2799 30.6552C54.0713 30.3244 52.8308 30.1526 51.584 30.1526C43.9186 30.1526 37.6845 36.3867 37.6845 44.0521C37.6845 46.4058 38.2888 48.7341 39.4211 50.7824C39.5992 51.1005 39.5929 51.4885 39.4084 51.8002C39.2239 52.1119 38.8868 52.3091 38.5242 52.3091L38.5305 52.3028Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M48.9662 44.743C49.3835 44.9873 49.7041 45.2876 49.9281 45.6438C50.1622 46 50.2792 46.3715 50.2792 46.7583V47.369C50.2792 47.9593 50.1316 48.4835 49.8365 48.9415C49.5413 49.3995 49.124 49.7557 48.5846 50.0102C48.0553 50.2545 47.4395 50.3766 46.7372 50.3766H45.2563C44.1672 50.3766 43.3123 50.0662 42.6914 49.4453C42.0807 48.8244 41.7754 47.9593 41.7754 46.8499H43.8517C43.8517 47.3792 43.9739 47.7914 44.2181 48.0865C44.4624 48.3715 44.8085 48.514 45.2563 48.514H46.7372C47.1647 48.514 47.5108 48.4122 47.7754 48.2087C48.04 47.9949 48.1723 47.715 48.1723 47.369V46.7583C48.1723 46.4428 48.0349 46.1883 47.7601 45.9949C47.4853 45.8015 47.1291 45.7049 46.6914 45.7049H44.7372V43.8728H46.6914C47.0782 43.8728 47.3886 43.7812 47.6227 43.598C47.8568 43.4046 47.9739 43.1552 47.9739 42.8499V42.2392C47.9739 41.9542 47.8619 41.7303 47.638 41.5674C47.4141 41.3944 47.124 41.3079 46.7678 41.3079H45.2868C44.8695 41.3079 44.5438 41.4555 44.3097 41.7507C44.0858 42.0356 43.9739 42.4428 43.9739 42.972H41.8517C41.8517 41.8626 42.152 40.9975 42.7525 40.3766C43.3632 39.7557 44.208 39.4453 45.2868 39.4453H46.7678C47.4192 39.4453 47.9942 39.5624 48.4929 39.7965C49.0019 40.0306 49.3937 40.3613 49.6685 40.7888C49.9433 41.2061 50.0807 41.6896 50.0807 42.2392V42.8499C50.0807 43.2265 49.984 43.5776 49.7907 43.9033C49.5973 44.229 49.3225 44.5089 48.9662 44.743Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M55.137 50.3766C54.4246 50.3766 53.7935 50.2239 53.2439 49.9186C52.6943 49.6031 52.2668 49.1603 51.9615 48.5904C51.6561 48.0204 51.5034 47.3639 51.5034 46.6209V43.201C51.5034 42.458 51.651 41.8015 51.9462 41.2316C52.2515 40.6616 52.679 40.2239 53.2286 39.9186C53.7783 39.6031 54.4144 39.4453 55.137 39.4453H56.7554C57.4576 39.4453 58.0785 39.6031 58.6179 39.9186C59.1574 40.2239 59.5747 40.6616 59.8699 41.2316C60.1752 41.8015 60.3279 42.458 60.3279 43.201V46.6209C60.3279 47.3639 60.1803 48.0204 59.8851 48.5904C59.59 49.1603 59.1727 49.6031 58.6332 49.9186C58.0938 50.2239 57.4678 50.3766 56.7554 50.3766H55.137ZM56.7248 48.514C57.1727 48.514 57.5289 48.3461 57.7935 48.0102C58.0683 47.6641 58.2057 47.2112 58.2057 46.6514V43.1705C58.2057 42.6107 58.0683 42.1629 57.7935 41.827C57.5289 41.4809 57.1727 41.3079 56.7248 41.3079H55.1676C54.6994 41.3079 54.3228 41.4809 54.0378 41.827C53.7528 42.1629 53.6103 42.6107 53.6103 43.1705V46.6514C53.6103 47.2112 53.7528 47.6641 54.0378 48.0102C54.3228 48.3461 54.6994 48.514 55.1676 48.514H56.7248Z',
        fill: '#19297C',
      },
      {
        windingRule: 'nonzero',
        data: 'M17.6705 35.3563C19.3288 35.3563 20.6731 34.012 20.6731 32.3537C20.6731 30.6955 19.3288 29.3512 17.6705 29.3512C16.0123 29.3512 14.668 30.6955 14.668 32.3537C14.668 34.012 16.0123 35.3563 17.6705 35.3563Z',
        fill: '#BA91B1',
      },
      {
        windingRule: 'nonzero',
        data: 'M17.6705 45.5789C19.3288 45.5789 20.6731 44.2347 20.6731 42.5764C20.6731 40.9181 19.3288 39.5739 17.6705 39.5739C16.0123 39.5739 14.668 40.9181 14.668 42.5764C14.668 44.2347 16.0123 45.5789 17.6705 45.5789Z',
        fill: '#BA91B1',
      },
      {
        windingRule: 'nonzero',
        data: 'M7.54356 45.5789C9.20182 45.5789 10.5461 44.2347 10.5461 42.5764C10.5461 40.9181 9.20182 39.5739 7.54356 39.5739C5.8853 39.5739 4.54102 40.9181 4.54102 42.5764C4.54102 44.2347 5.8853 45.5789 7.54356 45.5789Z',
        fill: '#BA91B1',
      },
      {
        windingRule: 'nonzero',
        data: 'M7.54356 35.3563C9.20182 35.3563 10.5461 34.012 10.5461 32.3537C10.5461 30.6955 9.20182 29.3512 7.54356 29.3512C5.8853 29.3512 4.54102 30.6955 4.54102 32.3537C4.54102 34.012 5.8853 35.3563 7.54356 35.3563Z',
        fill: '#BA91B1',
      },
      {
        windingRule: 'nonzero',
        data: 'M27.5006 45.5788C29.1589 45.5788 30.5031 44.2345 30.5031 42.5763C30.5031 40.918 29.1589 39.5737 27.5006 39.5737C25.8423 39.5737 24.498 40.918 24.498 42.5763C24.498 44.2345 25.8423 45.5788 27.5006 45.5788Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M27.5006 35.3562C29.1589 35.3562 30.5031 34.0119 30.5031 32.3536C30.5031 30.6954 29.1589 29.3511 27.5006 29.3511C25.8423 29.3511 24.498 30.6954 24.498 32.3536C24.498 34.0119 25.8423 35.3562 27.5006 35.3562Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M17.6725 25.5598C19.3307 25.5598 20.675 24.2155 20.675 22.5572C20.675 20.899 19.3307 19.5547 17.6725 19.5547C16.0142 19.5547 14.6699 20.899 14.6699 22.5572C14.6699 24.2155 16.0142 25.5598 17.6725 25.5598Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M37.6275 25.5598C39.2858 25.5598 40.6301 24.2155 40.6301 22.5572C40.6301 20.899 39.2858 19.5547 37.6275 19.5547C35.9693 19.5547 34.625 20.899 34.625 22.5572C34.625 24.2155 35.9693 25.5598 37.6275 25.5598Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M47.4186 25.5598C49.0768 25.5598 50.4211 24.2155 50.4211 22.5572C50.4211 20.899 49.0768 19.5547 47.4186 19.5547C45.7603 19.5547 44.416 20.899 44.416 22.5572C44.416 24.2155 45.7603 25.5598 47.4186 25.5598Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'nonzero',
        data: 'M27.5006 25.5598C29.1589 25.5598 30.5031 24.2155 30.5031 22.5572C30.5031 20.899 29.1589 19.5547 27.5006 19.5547C25.8423 19.5547 24.498 20.899 24.498 22.5572C24.498 24.2155 25.8423 25.5598 27.5006 25.5598Z',
        fill: '#E1D8E9',
      },
    ],
    size: {
      height: 68,
      width: 60,
    },
    viewBox: '0 0 68 60',
    translate: {
      x: 0,
      y: 0,
    },
  },

  wallet: {
    name: 'wallet',
    paths: [
      {
        data: 'M34.7797 13.2617C38.4454 13.2617 41.4169 10.293 41.4169 6.63084C41.4169 2.96873 38.4454 0 34.7797 0C31.1141 0 28.1426 2.96873 28.1426 6.63084C28.1426 10.293 31.1141 13.2617 34.7797 13.2617Z',
        fill: '#BA91B1',
      },
      {
        data: 'M34.7797 35.8528C38.4454 35.8528 41.4169 32.8841 41.4169 29.222C41.4169 25.5599 38.4454 22.5911 34.7797 22.5911C31.1141 22.5911 28.1426 25.5599 28.1426 29.222C28.1426 32.8841 31.1141 35.8528 34.7797 35.8528Z',
        fill: '#BA91B1',
      },
      {
        data: 'M12.3911 35.8528C16.0567 35.8528 19.0282 32.8841 19.0282 29.222C19.0282 25.5599 16.0567 22.5911 12.3911 22.5911C8.72547 22.5911 5.75391 25.5599 5.75391 29.222C5.75391 32.8841 8.72547 35.8528 12.3911 35.8528Z',
        fill: '#BA91B1',
      },
      {
        data: 'M12.3911 13.2617C16.0567 13.2617 19.0282 10.293 19.0282 6.63084C19.0282 2.96873 16.0567 0 12.3911 0C8.72547 0 5.75391 2.96873 5.75391 6.63084C5.75391 10.293 8.72547 13.2617 12.3911 13.2617Z',
        fill: '#BA91B1',
      },

      {
        data: 'M12.3911 13.2617C16.056M7.22646 4.7 13.2617 19.0282 10.293 19.0282 6.63084C19.0282 2.96873 16.0567 0 12.3911 0C8.72547 0 5.75391 2.96873 5.75391 6.63084C5.75391 10.293 8.72547 13.2617 12.3911 13.2617Z',
        fill: '#BA91B1',
      },
      {
        data: 'M43.9072 59.264H4.02808C2.22496 59.264 0.765625 57.8061 0.765625 56.0047V29.7266C0.765625 27.9252 2.22496 26.4673 4.02808 26.4673H43.9072C45.7104 26.4673 47.1697 27.9252 47.1697 29.7266L45.7665 37.9486C45.7665 37.9486 38.0138 38.1238 38.0138 42.9252C38.0138 47.7266 45.2824 48.3014 45.2824 48.3014L47.1697 55.9977C47.1697 57.7991 45.7104 59.257 43.9072 59.257V59.264Z',
        fill: '#E1D8E9',
      },
      {
        data: 'M46.5724 48.5397H42.5171C39.4231 48.5397 36.9043 46.0234 36.9043 42.9322C36.9043 39.8411 39.4231 37.3248 42.5171 37.3248H46.5724C47.9125 37.3248 48.9999 38.4112 48.9999 39.75V46.1145C48.9999 47.4533 47.9125 48.5397 46.5724 48.5397ZM42.5171 39.3855C40.5597 39.3855 38.974 40.9766 38.974 42.9252C38.974 44.8738 40.5667 46.472 42.5171 46.472H46.5724C46.7688 46.472 46.9372 46.3107 46.9372 46.1075V39.743C46.9372 39.5467 46.7759 39.3785 46.5724 39.3785H42.5171V39.3855Z',
        fill: '#19297C',
      },
      {
        data: 'M28.5974 32.7827H1.03136C0.463058 32.7827 0 32.3201 0 31.7524C0 31.1846 0.463058 30.722 1.03136 30.722H28.5974C29.1657 30.722 29.6287 31.1846 29.6287 31.7524C29.6287 32.3201 29.1657 32.7827 28.5974 32.7827Z',
        fill: '#19297C',
      },
      {
        data: 'M15.8633 55.1355H1.03136C0.463058 55.1355 0 54.6729 0 54.1051C0 53.5374 0.463058 53.0748 1.03136 53.0748H15.8633C16.4316 53.0748 16.8946 53.5374 16.8946 54.1051C16.8946 54.6729 16.4316 55.1355 15.8633 55.1355Z',
        fill: '#19297C',
      },
      {
        data: 'M46.137 32.7827H35.0587C34.4904 32.7827 34.0273 32.3201 34.0273 31.7524C34.0273 31.1846 34.4904 30.722 35.0587 30.722H46.137C46.7053 30.722 47.1684 31.1846 47.1684 31.7524C47.1684 32.3201 46.7053 32.7827 46.137 32.7827Z',
        fill: '#19297C',
      },
      {
        data: 'M46.1365 55.1355H22.4083C21.84 55.1355 21.377 54.6729 21.377 54.1051C21.377 53.5374 21.84 53.0748 22.4083 53.0748H46.1365C46.7048 53.0748 47.1679 53.5374 47.1679 54.1051C47.1679 54.6729 46.7048 55.1355 46.1365 55.1355Z',
        fill: '#19297C',
      },
      {
        data: 'M44.0397 60H3.12915C1.40321 60 0 58.5981 0 56.8738V28.9837C0 27.2594 1.40321 25.8575 3.12915 25.8575H44.0397C45.7656 25.8575 47.1688 27.2594 47.1688 28.9837V38.3551C47.1688 38.9229 46.7058 39.3855 46.1375 39.3855H42.5172C40.5597 39.3855 38.9741 40.9766 38.9741 42.9252C38.9741 44.8738 40.5667 46.472 42.5172 46.472H46.1375C46.7058 46.472 47.1688 46.9346 47.1688 47.5023V56.8738C47.1688 58.5981 45.7656 60 44.0397 60ZM3.12915 27.9252C2.54682 27.9252 2.06973 28.4019 2.06973 28.9837V56.8738C2.06973 57.4556 2.54682 57.9323 3.12915 57.9323H44.0397C44.622 57.9323 45.0991 57.4556 45.0991 56.8738V48.5397H42.5102C39.4161 48.5397 36.8973 46.0234 36.8973 42.9323C36.8973 39.8411 39.4161 37.3248 42.5102 37.3248H45.0991V28.9907C45.0991 28.4089 44.622 27.9322 44.0397 27.9322H3.12915V27.9252Z',
        fill: '#19297C',
      },
    ],
    rects: [
      { x: '37.8867', y: '39.2523', width: '9.82245', height: '7.71028', fill: 'white' },
    ],
    size: {
      height: 60,
      width: 49,
    },
    viewBox: '0 0 49 60',
    translate: {
      x: 0,
      y: 0,
    },
  },
  trending_flat: {
    name: 'trending_flat',
    paths: [
      {
        data:
          'M22 12L18 8V11H3V13H18V16L22 12Z',
      },
    ],
    size: {
      height: 24,
      width: 25,
    },
    viewBox: '0 0 25 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  trending_up: {
    name: 'trending_up',
    paths: [
      {
        data:
          'M12.5 4.5L14.2175 6.2175L10.5575 9.8775L7.5575 6.8775L2 12.4425L3.0575 13.5L7.5575 9L10.5575 12L15.2825 7.2825L17 9V4.5H12.5Z',
      },
    ],
    size: {
      height: 18,
      width: 19,
    },
    viewBox: '0 0 19 18',
    translate: {
      x: 0,
      y: 0,
    },
  },

  alarm_big: {
    name: 'alarm_big',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M11.8434 3.04275L9.26654 0L0 7.61501L2.57664 10.6578L11.8434 3.04275ZM30.7333 0.00114822L40.0001 7.61616L37.4232 10.6589L28.1565 3.0439L30.7333 0.00114822ZM21.0062 12.2632H17.9893V24.1505L27.5428 29.797L29.0513 27.3601L21.0062 22.6646V12.2632ZM19.9999 4.33772C10.0039 4.33772 1.89844 12.322 1.89844 22.1687C1.89844 32.0153 10.0039 39.9996 19.9999 39.9996C29.9959 39.9996 38.1014 32.0153 38.1014 22.1687C38.1014 12.322 29.9959 4.33772 19.9999 4.33772ZM5.9209 22.169C5.9209 29.8165 12.2363 36.0375 19.9998 36.0375C27.7633 36.0375 34.0787 29.8165 34.0787 22.169C34.0787 14.5215 27.7633 8.30047 19.9998 8.30047C12.2363 8.30047 5.9209 14.5215 5.9209 22.169Z',
      },
    ],
    size: {
      height: 40,
      width: 40,
    },
    viewBox: '0 0 40 40',
    translate: {
      x: 0,
      y: 0,
    },
  },
  alarm_big_lilac: {
    name: 'alarm_big_lilac',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#C49BBB',
        data:
          'M11.8434 3.04275L9.26654 0L0 7.61501L2.57664 10.6578L11.8434 3.04275ZM30.7333 0.00114822L40.0001 7.61616L37.4232 10.6589L28.1565 3.0439L30.7333 0.00114822ZM21.0062 12.2632H17.9893V24.1505L27.5428 29.797L29.0513 27.3601L21.0062 22.6646V12.2632ZM19.9999 4.33772C10.0039 4.33772 1.89844 12.322 1.89844 22.1687C1.89844 32.0153 10.0039 39.9996 19.9999 39.9996C29.9959 39.9996 38.1014 32.0153 38.1014 22.1687C38.1014 12.322 29.9959 4.33772 19.9999 4.33772ZM5.9209 22.169C5.9209 29.8165 12.2363 36.0375 19.9998 36.0375C27.7633 36.0375 34.0787 29.8165 34.0787 22.169C34.0787 14.5215 27.7633 8.30047 19.9998 8.30047C12.2363 8.30047 5.9209 14.5215 5.9209 22.169Z',
      },
    ],
    size: {
      height: 40,
      width: 40,
    },
    viewBox: '0 0 40 40',
    translate: {
      x: 0,
      y: 0,
    },
  },
  bell_red: {
    name: 'bell_red',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#C92121',
        data:
          'M35 32.7273V20.6061C35 13.1636 30.9 6.93333 23.75 5.28485V3.63636C23.75 1.62424 22.075 0 20 0C17.925 0 16.25 1.62424 16.25 3.63636V5.28485C9.075 6.93333 5 13.1394 5 20.6061V32.7273L0 37.5758V40H40V37.5758L35 32.7273ZM22.5 32.7273H17.5V27.8788H22.5V32.7273ZM22.5 23.0303H17.5V13.3333H22.5V23.0303ZM20 47.2727C22.75 47.2727 25 45.0909 25 42.4242H15C15 45.0909 17.225 47.2727 20 47.2727Z',
      },
    ],
    size: {
      height: 48,
      width: 48,
    },
    viewBox: '0 0 40 48',
    translate: {
      x: 0,
      y: 0,
    },
  },
  four_dots_lilac: {
    name: 'four_dots_lilac',
    paths: [
      {
        fill: '#C49BBB',
        windingRule: 'evenodd',
        data:
          'M7.44186 14.7989C11.5519 14.7989 14.8837 11.4861 14.8837 7.39946C14.8837 3.31285 11.5519 0 7.44186 0C3.33183 0 0 3.31285 0 7.39946C0 11.4861 3.33183 14.7989 7.44186 14.7989Z',
      },
      {
        fill: '#C49BBB',
        windingRule: 'evenodd',
        data:
          'M32.5591 39.9999C36.6691 39.9999 40.0009 36.6871 40.0009 32.6005C40.0009 28.5139 36.6691 25.201 32.5591 25.201C28.449 25.201 25.1172 28.5139 25.1172 32.6005C25.1172 36.6871 28.449 39.9999 32.5591 39.9999Z',
      },
      {
        fill: '#C49BBB',
        windingRule: 'evenodd',
        data:
          'M7.44186 39.9999C11.5519 39.9999 14.8837 36.6871 14.8837 32.6005C14.8837 28.5139 11.5519 25.201 7.44186 25.201C3.33183 25.201 0 28.5139 0 32.6005C0 36.6871 3.33183 39.9999 7.44186 39.9999Z',
      },
      {
        fill: '#C49BBB',
        windingRule: 'evenodd',
        data:
          'M32.5591 14.7989C36.6691 14.7989 40.0009 11.4861 40.0009 7.39946C40.0009 3.31285 36.6691 0 32.5591 0C28.449 0 25.1172 3.31285 25.1172 7.39946C25.1172 11.4861 28.449 14.7989 32.5591 14.7989Z',
      },
    ],
    size: {
      height: 40,
      width: 40,
    },
    viewBox: '0 0 40 40',
    translate: {
      x: 0,
      y: 0,
    },
  },
  four_dots: {
    name: 'four_dots',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M7.44186 14.7989C11.5519 14.7989 14.8837 11.4861 14.8837 7.39946C14.8837 3.31285 11.5519 0 7.44186 0C3.33183 0 0 3.31285 0 7.39946C0 11.4861 3.33183 14.7989 7.44186 14.7989Z',
      },
      {
        windingRule: 'evenodd',
        data:
          'M32.5591 39.9999C36.6691 39.9999 40.0009 36.6871 40.0009 32.6005C40.0009 28.5139 36.6691 25.201 32.5591 25.201C28.449 25.201 25.1172 28.5139 25.1172 32.6005C25.1172 36.6871 28.449 39.9999 32.5591 39.9999Z',
      },
      {
        windingRule: 'evenodd',
        data:
          'M7.44186 39.9999C11.5519 39.9999 14.8837 36.6871 14.8837 32.6005C14.8837 28.5139 11.5519 25.201 7.44186 25.201C3.33183 25.201 0 28.5139 0 32.6005C0 36.6871 3.33183 39.9999 7.44186 39.9999Z',
      },
      {
        windingRule: 'evenodd',
        data:
          'M32.5591 14.7989C36.6691 14.7989 40.0009 11.4861 40.0009 7.39946C40.0009 3.31285 36.6691 0 32.5591 0C28.449 0 25.1172 3.31285 25.1172 7.39946C25.1172 11.4861 28.449 14.7989 32.5591 14.7989Z',
      },
    ],
    size: {
      height: 40,
      width: 40,
    },
    viewBox: '0 0 40 40',
    translate: {
      x: 0,
      y: 0,
    },
  },
  account_balance_wallet_big: {
    name: 'account_balance_wallet_big',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#C49BBB',
        data:
          'M41.6842 4.43213V9.48476C43.0505 10.2604 44 11.6565 44 13.2964V26.5928C44 28.2327 43.0505 29.6288 41.6842 30.4044V35.4571C41.6842 37.8947 39.6 39.8892 37.0526 39.8892L20.9 40L4.63158 39.8892C2.06105 39.8892 0 37.8947 0 35.4571V4.43213C0 1.99446 2.06105 0 4.63158 0H37.0526C39.6 0 41.6842 1.99446 41.6842 4.43213ZM39.3685 26.5928V13.2964H23.158V26.5928H39.3685ZM4.63096 35.4571V4.43213H37.052V8.86426H23.1573C20.6099 8.86426 18.5257 10.8587 18.5257 13.2964V26.5928C18.5257 29.0305 20.6099 31.0249 23.1573 31.0249H37.052V35.4571H4.63096ZM26.632 19.9447C26.632 18.1089 28.1873 16.6206 30.1057 16.6206C32.0242 16.6206 33.5794 18.1089 33.5794 19.9447C33.5794 21.7806 32.0242 23.2688 30.1057 23.2688C28.1873 23.2688 26.632 21.7806 26.632 19.9447Z',
      },
    ],
    size: {
      height: 40,
      width: 44,
    },
    viewBox: '0 0 44 40',
    translate: {
      x: 0,
      y: 0,
    },
  },

  add_to_photos: {
    name: 'add_to_photos',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M6 0H18C19.1 0 20 0.9 20 2V14C20 15.1 19.1 16 18 16H6C4.9 16 4 15.1 4 14V2C4 0.9 4.9 0 6 0ZM0 4H2V18H16V20H2C0.9 20 0 19.1 0 18V4ZM18 14H6V2H18V14ZM13 13H11V9H7V7H11V3H13V7H17V9H13V13Z',
      },
    ],
    size: {
      height: 20,
      width: 20,
    },
    viewBox: '0 0 20 20',
    translate: {
      x: 0,
      y: 0,
    },
  },
  add_a_photo: {
    name: 'add_a_photo',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M8.5 6.5H5.5V9.5H3.5V6.5H0.5V4.5H3.5V1.5H5.5V4.5H8.5V6.5ZM18.33 6.5H21.5C22.6 6.5 23.5 7.4 23.5 8.5V20.5C23.5 21.6 22.6 22.5 21.5 22.5H5.5C4.4 22.5 3.5 21.6 3.5 20.5V11.5H5.5V20.5H21.5V8.5H17.45L15.62 6.5H10.5V4.5H16.5L18.33 6.5ZM13.5 19.5C10.74 19.5 8.5 17.26 8.5 14.5C8.5 11.74 10.74 9.5 13.5 9.5C16.26 9.5 18.5 11.74 18.5 14.5C18.5 17.26 16.26 19.5 13.5 19.5ZM13.5 11.5C15.15 11.5 16.5 12.85 16.5 14.5C16.5 16.15 15.15 17.5 13.5 17.5C11.85 17.5 10.5 16.15 10.5 14.5C10.5 12.85 11.85 11.5 13.5 11.5Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  mobile_friendly_24: {
    name: 'mobile_friendly_24',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M8.90375 1H18.9037C20.0037 1 20.9037 1.9 20.9037 3V21C20.9037 22.1 20.0037 23 18.9037 23H8.90375C7.80375 23 6.90375 22.1 6.90375 21V18H8.90375V20H18.9037V4H8.90375V6H6.90375V3C6.90375 1.9 7.80375 1 8.90375 1ZM4.36375 10.92L6.91375 13.47L12.8237 7.54L14.0938 8.81L6.90375 16L3.09375 12.19L4.36375 10.92Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  ellipse: {
    name: 'ellipse',
    paths: [
      {
        windingRule: 'evenodd',
        data:
          'M11.1528 22.9999C17.3123 22.9999 22.3056 18.0307 22.3056 11.9007C22.3056 5.77082 17.3123 0.801544 11.1528 0.801544C4.99328 0.801544 0 5.77082 0 11.9007C0 18.0307 4.99328 22.9999 11.1528 22.9999Z',
      },
    ],
    size: {
      height: 8,
      width: 8,
    },
    viewBox: '0 0 28 28',
    translate: {
      x: 10,
      y: 10,
    },
  },
  calendar_today_24: {
    name: 'calendar_today_24',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#19297C',
        data: 'M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V10H20V21ZM4 8H20V5H4V8Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  check_box: {
    name: 'check_box',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#575481',
        data: 'M59.375 9.375H15.625C12.1875 9.375 9.375 12.1875 9.375 15.625V59.375C9.375 62.8125 12.1875 65.625 15.625 65.625H59.375C62.8125 65.625 65.625 62.8125 65.625 59.375V15.625C65.625 12.1875 62.8125 9.375 59.375 9.375ZM59.375 59.375H15.625V15.625H59.375V59.375ZM51.8125 23.6875L56.2188 28.125L31.2188 53.125L18.7188 40.6562L23.1562 36.25L31.2188 44.2812L51.8125 23.6875Z',
      },
    ],
    size: {
      height: 75,
      width: 75,
    },
    viewBox: '0 0 75 75',
    translate: {
      x: 0,
      y: 0,
    },
  },
  indeterminate_check_box: {
    name: 'indeterminate_check_box',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#575481',
        data: 'M59.375 9.375H15.625C12.1875 9.375 9.375 12.1875 9.375 15.625V59.375C9.375 62.8125 12.1875 65.625 15.625 65.625H59.375C62.8125 65.625 65.625 62.8125 65.625 59.375V15.625C65.625 12.1875 62.8125 9.375 59.375 9.375ZM59.375 59.375H15.625V15.625H59.375V59.375ZM53.125 34.375H21.875V40.625H53.125V34.375Z',
      },
    ],
    size: {
      height: 75,
      width: 75,
    },
    viewBox: '0 0 75 75',
    translate: {
      x: 0,
      y: 0,
    },
  },

  arrow_left_in_circle: {
    name: 'arrow_left_in_circle',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#ffffff',
        data: 'M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z',
      }, {
        windingRule: 'evenodd',
        fill: '#19297C',
        data: 'M11 21.5C16.799 21.5 21.5 16.799 21.5 11C21.5 5.20101 16.799 0.5 11 0.5C5.20101 0.5 0.5 5.20101 0.5 11C0.5 16.799 5.20101 21.5 11 21.5ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z',
      }, {
        windingRule: 'evenodd',
        fill: '#19297C',
        data: 'M8.82843 14.5359L5.64645 11.3539C5.45118 11.1586 5.45118 10.842 5.64645 10.6468L8.82843 7.46481C9.02369 7.26954 9.34027 7.26954 9.53553 7.46481C9.7308 7.66007 9.7308 7.97665 9.53553 8.17191L7.20711 10.5003H17C17.2761 10.5003 17.5 10.7242 17.5 11.0003C17.5 11.2765 17.2761 11.5003 17 11.5003H7.20711L9.53553 13.8288C9.7308 14.024 9.7308 14.3406 9.53553 14.5359C9.34027 14.7311 9.02369 14.7311 8.82843 14.5359Z',
      },
    ],
    size: {
      height: 22,
      width: 22,
    },
    viewBox: '0 0 22 22',
    translate: {
      x: 0,
      y: 0,
    },
  },

  kontomatik: {
    name: 'kontomatik',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.51 17.38 16.93 18.28C15.57 19.36 13.86 20 12 20C10.14 20 8.43 19.36 7.07 18.28ZM12 14.5C13.46 14.5 16.93 15.09 18.36 16.83C19.38 15.49 20 13.82 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12C4 13.82 4.62 15.49 5.64 16.83C7.07 15.09 10.54 14.5 12 14.5ZM12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM10.5 9.5C10.5 10.33 11.17 11 12 11C12.83 11 13.5 10.33 13.5 9.5C13.5 8.67 12.83 8 12 8C11.17 8 10.5 8.67 10.5 9.5Z',
      },
    ],
    size: {
      height: 22,
      width: 22,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  refresh: {
    name: 'refresh',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M17.6478 6.35C16.1978 4.9 14.2078 4 11.9978 4C7.57781 4 4.00781 7.58 4.00781 12C4.00781 16.42 7.57781 20 11.9978 20C15.7278 20 18.8378 17.45 19.7278 14H17.6478C16.8278 16.33 14.6078 18 11.9978 18C8.68781 18 5.99781 15.31 5.99781 12C5.99781 8.69 8.68781 6 11.9978 6C13.6578 6 15.1378 6.69 16.2178 7.78L12.9978 11H19.9978V4L17.6478 6.35Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  do_disturb: {
    name: 'do_disturb',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.795 10 2 8.205 2 6C2 3.795 3.795 2 6 2C8.205 2 10 3.795 10 6C10 8.205 8.205 10 6 10ZM8.5 5.5H3.5V6.5H8.5V5.5Z',
      },
    ],
    size: {
      height: 12,
      width: 12,
    },
    viewBox: '0 0 12 12',
    translate: {
      x: 0,
      y: 0,
    },
  },
  contact_support: {
    name: 'contact_support',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M4.75 9.84656V11.6466L5.465 11.3016C8.03 10.0666 9.75 7.57656 9.75 5.10156C9.75 2.48156 7.62 0.351562 5 0.351562C2.38 0.351562 0.25 2.48156 0.25 5.10156C0.25 7.63656 2.245 9.71656 4.75 9.84656ZM1.25 5.10156C1.25 3.03156 2.93 1.35156 5 1.35156C7.07 1.35156 8.75 3.03156 8.75 5.10156C8.75 6.96156 7.57 8.85156 5.75 10.0016V8.85156H5C2.93 8.85156 1.25 7.17156 1.25 5.10156ZM5.5 7.10156V8.10156H4.5V7.10156H5.5ZM5.38522 4.7624C4.97106 5.07986 4.5 5.44093 4.5 6.35156H5.5C5.5 5.80388 5.85551 5.49319 6.22038 5.17433C6.60499 4.83822 7 4.49302 7 3.85156C7 2.74656 6.105 1.85156 5 1.85156C3.895 1.85156 3 2.74656 3 3.85156H4C4 3.30156 4.45 2.85156 5 2.85156C5.55 2.85156 6 3.30156 6 3.85156C6 4.29117 5.71012 4.51337 5.38522 4.7624Z',
      },
    ],
    size: {
      height: 12,
      width: 12,
    },
    viewBox: '0 0 12 12',
    translate: {
      x: 0,
      y: 0,
    },
  },
  power_settings: {
    name: 'power_settings',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M5.5 1.5H6.5V6.5H5.5V1.5ZM8.205 3.295L8.915 2.585C9.885 3.41 10.5 4.63 10.5 6C10.5 8.485 8.485 10.5 6 10.5C3.515 10.5 1.5 8.485 1.5 6C1.5 4.63 2.115 3.41 3.085 2.585L3.79 3.29C3.005 3.93 2.5 4.905 2.5 6C2.5 7.935 4.065 9.5 6 9.5C7.935 9.5 9.5 7.935 9.5 6C9.5 4.905 8.995 3.93 8.205 3.295Z',
      },
    ],
    size: {
      height: 12,
      width: 12,
    },
    viewBox: '0 0 12 12',
    translate: {
      x: 0,
      y: 0,
    },
  },
  mode_24: {
    name: 'mode_24',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM3 17.25L14.06 6.19L17.81 9.94L6.75 21H3V17.25Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  explore_off_24: {
    name: 'explore_off_24',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M20 12C20 7.59 16.41 4 12 4C10.52 4 9.14 4.41 7.95 5.12L6.49 3.66C8.07 2.61 9.96 2 12 2C17.52 2 22 6.48 22 12C22 14.04 21.39 15.93 20.34 17.52L18.88 16.06C19.59 14.86 20 13.48 20 12ZM17.5 6.5L14.91 12.08L11.92 9.09L17.5 6.5ZM2.1 4.93L3.66 6.49C2.61 8.07 2 9.96 2 12C2 17.52 6.48 22 12 22C14.04 22 15.93 21.39 17.51 20.34L19.07 21.9L20.48 20.49L3.51 3.51L2.1 4.93ZM9.1 11.92L5.12 7.94C4.41 9.14 4 10.52 4 12C4 16.41 7.59 20 12 20C13.48 20 14.86 19.59 16.06 18.89L12.08 14.91L6.5 17.5L9.1 11.92Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },

  alarm_off_24: {
    name: 'alarm_off_24',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M8.16203 3.44625L7.70203 3.82625L6.28203 2.40625L6.88203 1.90625L8.16203 3.44625ZM17.5585 1.90725L22.1659 5.75085L20.8847 7.28665L16.2773 3.44305L17.5585 1.90725ZM10.262 6.38625C10.882 6.20625 11.542 6.09625 12.222 6.09625C16.082 6.09625 19.222 9.23625 19.222 13.0963C19.222 13.7762 19.112 14.4362 18.932 15.0562L20.492 16.6163C20.962 15.5363 21.222 14.3463 21.222 13.0963C21.222 8.12625 17.192 4.09625 12.222 4.09625C10.972 4.09625 9.78203 4.35625 8.69203 4.81625L10.262 6.38625ZM1.83203 3.60625L3.24203 2.19625L21.622 20.5863L20.212 21.9963L18.112 19.8963C16.532 21.2663 14.472 22.0963 12.222 22.0963C7.25203 22.0963 3.22203 18.0662 3.22203 13.0962C3.22203 10.8462 4.05203 8.78625 5.42203 7.20625L4.62203 6.40625L3.56203 7.28625L2.28203 5.74625L3.20203 4.97625L1.83203 3.60625ZM12.222 20.0963C8.36203 20.0963 5.22203 16.9562 5.22203 13.0962C5.22203 11.3962 5.83203 9.83625 6.84203 8.62625L16.692 18.4762C15.482 19.4862 13.922 20.0963 12.222 20.0963Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },

  grid_off_24: {
    name: 'grid_off_24',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M0.566406 1.97973L1.97641 0.570312L23.4364 22.0214L22.0264 23.4308L20.0164 21.4216H4.56641C3.46641 21.4216 2.56641 20.522 2.56641 19.4225V3.97889L0.566406 1.97973ZM8.56641 3.42912V4.31875L10.5664 6.31792V3.42912H14.5664V7.42745H11.6764L13.6764 9.42662H14.5664V10.3163L16.5664 12.3154V9.42662H20.5664V13.425H17.6764L19.6764 15.4241H20.5664V16.3138L22.5664 18.3129V3.42912C22.5664 2.32958 21.6664 1.42995 20.5664 1.42995H5.67641L7.67641 3.42912H8.56641ZM16.5664 3.42912H20.5664V7.42745H16.5664V3.42912ZM10.5664 11.9756L12.0164 13.425H10.5664V11.9756ZM6.01641 7.42746L4.56641 5.97806V7.42746H6.01641ZM8.56641 19.4225H4.56641V15.4241H8.56641V19.4225ZM4.56641 13.425H8.56641V9.97639L8.01641 9.42662H4.56641V13.425ZM14.5664 19.4225H10.5664V15.4241H14.0164L14.5664 15.9739V19.4225ZM16.5664 17.9731V19.4225H18.0164L16.5664 17.9731Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },

  warning: {
    name: 'warning',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M46 43L24 5L2 43H46ZM22 37V33H26V37H22ZM22 29H26V21H22V29Z',
      },
    ],
    size: {
      height: 48,
      width: 48,
    },
    viewBox: '0 0 48 48',
    translate: {
      x: 0,
      y: 0,
    },
  },

  session_expired: {
    name: 'session_expired',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M58.9574 88.8343L60.3033 89.9991L60.0626 101C37.8258 87.8458 13.5013 69.8703 11.1239 43.661C10.2004 33.4963 14.4346 25.1949 23.9738 21.9855C36.0918 17.9109 50.4448 27.034 54.4383 39.0064L52.2917 56.3439L56.4817 61.5447L63 69.6359L57.7638 75.6946L51.7809 82.616L58.9574 88.8343Z',
        fill: '#E1D8E9',
      },
      {
        windingRule: 'evenodd',
        data: 'M57.9131 89.5439C58.3588 89.931 58.802 90.3181 59.2478 90.7029L58.8922 89.8517C58.8215 93.0472 58.7533 96.2427 58.6827 99.4382C58.673 99.8902 58.6632 100.342 58.6535 100.794L60.485 99.7556C54.1233 95.9782 47.8808 91.982 41.972 87.5386C41.2608 87.0048 40.7031 86.5768 39.9115 85.9541C39.1808 85.3794 38.4575 84.8 37.739 84.2109C36.3093 83.0375 34.9064 81.8329 33.5376 80.5898C30.8365 78.1421 28.262 75.5525 25.8825 72.797C23.5686 70.1209 21.5349 67.4063 19.6181 64.2757C18.7023 62.7801 17.8523 61.2437 17.0851 59.6688C16.9048 59.3009 16.7295 58.9306 16.559 58.5603C16.4664 58.3583 16.3739 58.154 16.2838 57.9496C16.2375 57.8486 16.1936 57.7452 16.1498 57.6442C16.1303 57.5985 16.0012 57.3028 16.0962 57.5216C15.7455 56.6993 15.4191 55.8674 15.1147 55.0282C14.5155 53.3739 14.0065 51.686 13.5949 49.9765C13.383 49.0916 13.1979 48.202 13.0371 47.3076C12.964 46.894 12.8958 46.4804 12.8325 46.0645C12.8155 45.9515 12.7984 45.836 12.7838 45.723C12.7278 45.3479 12.813 45.9635 12.7643 45.586C12.7351 45.3576 12.7059 45.1267 12.6791 44.8983C12.4745 43.1359 12.3795 41.3662 12.4769 39.5941C12.5013 39.1637 12.5354 38.7333 12.5816 38.3053C12.6011 38.1298 12.6231 37.9519 12.645 37.7764C12.6888 37.4253 12.6036 38.024 12.6596 37.6778C12.6815 37.5383 12.701 37.4013 12.7253 37.2618C12.8544 36.4828 13.0249 35.7085 13.2393 34.9463C13.4536 34.1841 13.7215 33.4171 14.026 32.6717C14.1526 32.364 13.9212 32.8978 14.0601 32.5948C14.1015 32.5058 14.1404 32.4145 14.1818 32.3255C14.25 32.1764 14.3207 32.0273 14.3937 31.8807C14.574 31.5152 14.7688 31.1545 14.9734 30.8011C15.3582 30.1423 15.7845 29.5075 16.2545 28.9016C16.0767 29.13 16.2789 28.8727 16.3081 28.8391C16.369 28.7621 16.4323 28.6876 16.4957 28.613C16.6004 28.488 16.7076 28.3654 16.8172 28.2428C17.0997 27.9254 17.3968 27.6176 17.7037 27.3219C17.9668 27.0694 18.2347 26.8241 18.5123 26.5885C18.6658 26.4587 18.8192 26.3312 18.9775 26.2086C19.0311 26.1677 19.0823 26.1269 19.1358 26.0836C18.9093 26.2591 19.2528 25.997 19.2942 25.9682C19.9615 25.4801 20.6654 25.04 21.3912 24.6457C22.8964 23.8306 24.1848 23.3161 25.9604 22.8857C26.3404 22.7943 26.7227 22.7126 27.1076 22.6452C27.317 22.6092 27.5265 22.5755 27.736 22.5442C28.0867 22.4913 27.4802 22.5707 27.8334 22.5322C27.9381 22.5202 28.0428 22.5082 28.15 22.4962C28.9927 22.4096 29.8379 22.3783 30.6855 22.4C31.0727 22.4096 31.4624 22.4312 31.8497 22.4625C32.0616 22.4793 32.2735 22.501 32.4829 22.5226C32.5877 22.5346 32.6948 22.5466 32.7996 22.5611C32.5 22.525 32.9506 22.5827 33.0017 22.5923C33.8128 22.715 34.6141 22.8833 35.4057 23.09C36.2386 23.3089 37.0619 23.5733 37.8681 23.8811C38.0361 23.946 38.2042 24.0109 38.3722 24.0783C38.399 24.0903 38.7303 24.2298 38.4818 24.124C38.5817 24.1672 38.6815 24.2081 38.7814 24.2538C39.1808 24.4293 39.5754 24.6145 39.9651 24.8068C41.5093 25.5738 42.9706 26.4899 44.3468 27.5214C44.1422 27.3675 44.432 27.5888 44.4515 27.6008C44.5392 27.6681 44.6244 27.7378 44.7121 27.8052C44.885 27.9422 45.0555 28.0817 45.226 28.2235C45.5646 28.5072 45.8982 28.7982 46.2222 29.0963C46.8457 29.6686 47.4448 30.2649 48.0148 30.89C48.3119 31.2146 48.6017 31.5465 48.8818 31.8855C48.9988 32.0273 49.1132 32.1692 49.2277 32.3111C49.4566 32.5924 49.0889 32.1259 49.3081 32.4121C49.3958 32.5275 49.4859 32.6429 49.5736 32.7607C50.0948 33.4604 50.5843 34.1841 51.0349 34.9319C51.4855 35.6797 51.8581 36.3746 52.2113 37.1248C52.3039 37.3195 52.3915 37.5167 52.4792 37.7138C52.6254 38.0384 52.3891 37.4926 52.5255 37.822C52.5523 37.8894 52.5815 37.9543 52.6083 38.0216C52.6546 38.1346 53.0711 39.3296 53.0954 39.3272C52.9761 39.3441 53.1198 38.993 53.0784 39.1637C53.0638 39.2214 53.0638 39.2863 53.0565 39.3441L52.9688 40.0461C52.4451 44.2972 51.919 48.5482 51.3954 52.7993C51.2931 53.6336 51.1908 54.4656 51.0861 55.2999C51.0422 55.6461 50.9667 56.0044 50.957 56.3531C50.9424 56.8171 51.2712 57.1537 51.544 57.4928L52.3915 58.5483C53.1295 59.4668 53.8675 60.3853 54.6055 61.3038C56.7513 63.9751 58.897 66.6465 61.0428 69.3178C61.3399 69.6881 61.6371 70.0583 61.9367 70.4286V68.7287C60.3292 70.5969 58.7192 72.4628 57.1117 74.331C55.7381 75.9252 54.3644 77.5193 52.9907 79.1159C52.2649 79.9574 51.5391 80.8014 50.8133 81.6429C50.409 82.1142 50.2872 82.886 50.8133 83.3429C52.8908 85.1486 54.966 86.9543 57.0435 88.7577C57.3382 89.0149 57.6354 89.2722 57.9301 89.5295C58.4245 89.9575 59.1674 90.008 59.6521 89.5295C60.0954 89.0919 60.1465 88.2599 59.6521 87.8296C57.5745 86.0238 55.4994 84.2181 53.4218 82.4148L52.5352 81.6429V83.3429C54.1622 81.4554 55.7868 79.5679 57.4137 77.6804C58.7095 76.1776 60.0028 74.6749 61.2961 73.1721C62.0852 72.2584 62.8719 71.3423 63.6611 70.4286C64.1263 69.89 64.0995 69.2745 63.6611 68.7287C62.1437 66.8388 60.6263 64.9513 59.1089 63.0614C57.9106 61.5683 56.7099 60.0751 55.5115 58.582C54.6883 57.5553 53.8626 56.531 53.0394 55.5043L53.395 56.3555C53.7311 53.636 54.0648 50.9166 54.4009 48.1972C54.642 46.2472 54.8832 44.2948 55.1218 42.3448C55.2509 41.2916 55.4409 40.2289 55.514 39.1709C55.5383 38.7958 55.3581 38.4232 55.2315 38.0793C54.9587 37.3436 54.6518 36.6198 54.3157 35.9105C53.697 34.6025 52.9615 33.3522 52.1285 32.1668C50.4017 29.7119 48.3095 27.5286 45.9153 25.6989C41.2146 22.1283 35.3496 19.7743 29.3508 20.0172C23.498 20.2528 17.7865 23.0179 14.2038 27.62C10.66 32.1716 9.61509 38.1346 10.1193 43.749C10.6721 49.9019 12.4501 55.8577 15.2243 61.3879C17.9521 66.8244 21.6104 71.7775 25.7266 76.2666C29.945 80.8663 34.675 84.9899 39.6412 88.7841C44.6926 92.6456 49.9876 96.1802 55.4093 99.5127C56.6831 100.297 57.9666 101.068 59.2526 101.833C60.0612 102.314 61.0647 101.691 61.0842 100.794C61.1621 97.2141 61.2401 93.6363 61.3205 90.0561C61.3302 89.5944 61.1841 89.1881 60.8212 88.8731C60.4242 88.5292 60.0296 88.1854 59.6326 87.8416C59.1382 87.4136 58.3953 87.3631 57.9106 87.8416C57.4673 88.2792 57.4138 89.1111 57.9106 89.5415L57.9131 89.5439Z',
        fill: '#19297C',
      },
      {
        windingRule: 'evenodd',
        data: 'M109.941 42.2169C108.215 68.625 84.7412 87.26 63.2073 101L65.1353 90.1062L58 81.468L70.888 70.2802L62.5365 55.4392L67.2878 38.5371C70.9339 26.4086 84.6954 17.3183 96.8161 20.7211C105.604 23.1881 110.609 31.977 109.941 42.2169Z',
        fill: '#BA91B1',
      },
      {
        windingRule: 'evenodd',
        data: 'M108.518 42.2925C108.476 42.9237 108.42 43.5524 108.354 44.1812C108.32 44.4932 108.283 44.8051 108.244 45.1147C108.235 45.192 108.225 45.2694 108.215 45.3468C108.222 45.296 108.247 45.1292 108.21 45.3734C108.188 45.5282 108.166 45.683 108.142 45.8353C107.954 47.0759 107.715 48.3092 107.425 49.5329C106.859 51.927 106.103 54.2727 105.18 56.5556C105.132 56.6789 105.08 56.8023 105.029 56.9256C105 56.9957 104.971 57.0659 104.941 57.136C104.929 57.1626 104.837 57.3827 104.893 57.2545C104.949 57.1263 104.854 57.344 104.841 57.373C104.819 57.4262 104.795 57.477 104.773 57.5302C104.697 57.7043 104.619 57.8784 104.541 58.0525C104.293 58.6063 104.034 59.1577 103.766 59.7042C103.229 60.7997 102.656 61.8758 102.048 62.935C100.824 65.0704 99.465 67.1284 98.0014 69.1089C97.816 69.358 97.6306 69.6071 97.4427 69.8538C97.3476 69.9771 97.2549 70.1004 97.1598 70.2238C97.1134 70.2842 97.0646 70.3471 97.0183 70.4076C96.889 70.5744 97.0354 70.3858 96.9573 70.485C96.5719 70.9759 96.1816 71.4619 95.784 71.9456C94.9863 72.9153 94.1618 73.8657 93.3202 74.7968C91.6029 76.6975 89.8002 78.5209 87.9341 80.279C86.0679 82.0371 84.1262 83.7396 82.1454 85.3792C80.1646 87.0188 78.179 88.5641 76.1421 90.0755C72.0293 93.125 67.7775 95.9883 63.4549 98.7403C62.9304 99.074 62.4035 99.4077 61.8766 99.739C62.4743 100.194 63.0719 100.648 63.6671 101.105C64.2453 97.8866 64.8234 94.6679 65.404 91.4491C65.4747 91.0549 65.5528 90.6632 65.6162 90.269C65.704 89.7273 65.5235 89.3525 65.1966 88.9655L64.7526 88.4359C63.5208 86.968 62.2864 85.4977 61.0546 84.0298C60.0666 82.8521 59.0762 81.6744 58.0883 80.4967V82.2064C59.5519 80.9562 61.0131 79.7059 62.4767 78.4581L69.507 72.451C70.0437 71.9915 70.5803 71.5345 71.117 71.075C71.5268 70.7244 71.561 70.0521 71.3073 69.6095C70.3559 67.9457 69.4045 66.282 68.4532 64.6182C66.9383 61.9677 65.421 59.3173 63.9062 56.6644C63.5598 56.0574 63.211 55.4504 62.8646 54.8434L62.9865 55.7745C63.8915 52.6017 64.799 49.4289 65.704 46.2585C66.2553 44.3239 66.809 42.3892 67.3603 40.457C67.4921 39.9976 67.6214 39.5357 67.7555 39.0762C67.8336 38.8102 67.919 38.5442 68.0068 38.283C68.1312 37.9202 68.2629 37.5575 68.4044 37.202C68.4459 37.1004 68.4873 36.9989 68.5288 36.8973C68.6654 36.5612 68.4312 37.1125 68.5776 36.7812C68.6654 36.5805 68.7557 36.3798 68.8484 36.1791C69.5436 34.6942 70.3925 33.2771 71.3609 31.9519C71.4805 31.7875 71.6049 31.6254 71.7268 31.461C71.9488 31.1684 71.5805 31.6399 71.8098 31.3546C71.8561 31.2965 71.9025 31.2385 71.9488 31.1805C72.2293 30.8322 72.5172 30.4937 72.8148 30.1599C73.3588 29.5481 73.932 28.9605 74.5272 28.397C75.1224 27.8335 75.803 27.2483 76.4763 26.7187C76.5348 26.6728 76.5934 26.6268 76.6519 26.5809C76.4519 26.7356 76.7446 26.5107 76.7617 26.4986C76.9105 26.3874 77.0618 26.2762 77.213 26.1673C77.5765 25.9062 77.9448 25.6547 78.3205 25.4128C79.0059 24.9679 79.7109 24.5543 80.433 24.1723C80.7916 23.9812 81.1575 23.7998 81.5258 23.6257C81.6917 23.5459 81.86 23.4685 82.0283 23.3936C82.1283 23.3476 82.2308 23.3041 82.3332 23.2606C82.4015 23.2315 82.4699 23.2025 82.5357 23.1735C82.4137 23.2243 82.4186 23.2219 82.5504 23.1687C84.0481 22.5713 85.5849 22.0901 87.1705 21.7806C87.5633 21.7032 87.956 21.6403 88.3536 21.5823C88.7122 21.5291 88.1024 21.6089 88.461 21.5678C88.5341 21.5605 88.6049 21.5508 88.6781 21.5436C88.9293 21.5145 89.183 21.4904 89.4343 21.471C90.2271 21.4106 91.0247 21.3912 91.8224 21.4178C92.22 21.4323 92.6177 21.4565 93.0153 21.4928C93.1958 21.5097 93.3763 21.5315 93.5568 21.5508C93.9179 21.5895 93.3056 21.5121 93.6642 21.5653C93.7715 21.5823 93.8813 21.5968 93.9886 21.6137C94.8204 21.7467 95.6425 21.9305 96.4475 22.1699C96.7914 22.2715 97.1354 22.3851 97.472 22.5085C97.6721 22.581 97.8721 22.6584 98.0697 22.7382C98.116 22.7576 98.2868 22.8253 98.0697 22.7382C98.199 22.7938 98.3283 22.8494 98.4551 22.9099C99.1503 23.2291 99.8236 23.5943 100.47 24.003C100.79 24.2061 101.102 24.4189 101.407 24.6414C101.49 24.7019 101.573 24.7623 101.653 24.8252C101.468 24.6825 101.614 24.7962 101.651 24.8252C101.836 24.9775 102.024 25.1251 102.204 25.2822C102.775 25.7732 103.312 26.3028 103.814 26.8614C104.066 27.1419 104.31 27.4321 104.541 27.7296C104.385 27.5313 104.683 27.9182 104.727 27.9786C104.849 28.1455 104.968 28.3148 105.085 28.4865C105.539 29.1491 105.949 29.8431 106.315 30.5565C106.476 30.8709 106.629 31.1901 106.773 31.5142C106.817 31.6109 106.861 31.7101 106.903 31.8068C106.795 31.5553 106.934 31.8842 106.944 31.9132C107.025 32.1139 107.103 32.3146 107.178 32.5154C107.456 33.2674 107.693 34.0365 107.888 34.8152C107.988 35.2118 108.076 35.6108 108.154 36.0122C108.193 36.2153 108.23 36.4185 108.264 36.6216C108.278 36.7135 108.296 36.8078 108.31 36.9021C108.318 36.9457 108.383 37.4051 108.347 37.144C108.459 37.9855 108.525 38.8319 108.552 39.6808C108.579 40.5296 108.559 41.4292 108.503 42.3022C108.461 42.9358 109.093 43.5403 109.723 43.5113C110.418 43.4799 110.898 42.9793 110.942 42.3022C111.245 37.5889 110.371 32.733 108.02 28.5929C105.8 24.6849 102.28 21.6572 98.0184 20.1385C93.7569 18.6199 88.8 18.6803 84.3945 19.9644C79.8817 21.28 75.7347 23.7998 72.3952 27.0742C69.0557 30.3486 66.6846 34.0776 65.4235 38.3362C64.8624 40.2345 64.3355 42.145 63.7915 44.0482C62.9573 46.9671 62.123 49.8859 61.2912 52.8048C61.0789 53.5448 60.8472 54.2824 60.6569 55.0297C60.4667 55.7769 60.8374 56.2267 61.1668 56.8023C62.5206 59.1698 63.8745 61.5373 65.2259 63.9048C66.4773 66.0933 67.7287 68.2819 68.9801 70.4704C69.0508 70.5938 69.1191 70.7147 69.1899 70.838L69.3801 69.3725C67.9165 70.6228 66.4553 71.8731 64.9917 73.1209L57.9614 79.1279C57.4248 79.5874 56.8881 80.0445 56.3514 80.5039C55.8148 80.9634 55.9563 81.7421 56.3514 82.2137C58.4615 84.7263 60.5691 87.2389 62.6792 89.7515C62.9743 90.1045 63.2695 90.4552 63.5671 90.8083L63.2524 89.633C62.6841 92.7889 62.1181 95.9471 61.5497 99.103C61.4668 99.5601 61.3863 100.015 61.3034 100.472C61.2155 100.958 61.3204 101.432 61.74 101.744C62.1206 102.024 62.6743 102.102 63.0939 101.838C67.4628 99.0933 71.7707 96.2446 75.9445 93.2121C80.2549 90.0852 84.436 86.7721 88.3683 83.1858C92.2176 79.672 95.8084 75.8898 99.0015 71.7787C102.075 67.8248 104.751 63.5517 106.771 58.9715C108.849 54.2606 110.223 49.3128 110.776 44.1957C110.845 43.5669 110.898 42.9382 110.94 42.307C110.981 41.6758 110.347 41.0689 109.72 41.0979C109.022 41.1293 108.547 41.6299 108.5 42.307L108.518 42.2925Z',
        fill: '#19297C',
      },
    ],
    size: {
      height: 120,
      width: 121,
    },
    viewBox: '0 0 121 120',
    translate: {
      x: 0,
      y: 0,
    },
  },
  cloud_upload_24: {
    name: 'cloud_upload_24',
    paths: [
      {
        windingRule: 'evenodd',
        fill: '#575481',
        data: 'M58.05 30.12C56.01 19.77 46.92 12 36 12C27.33 12 19.8 16.92 16.05 24.12C7.02 25.08 0 32.73 0 42C0 51.93 8.07 60 18 60H57C65.28 60 72 53.28 72 45C72 37.08 65.85 30.66 58.05 30.12ZM57 54H18C11.37 54 6 48.63 6 42C6 35.85 10.59 30.72 16.68 30.09L19.89 29.76L21.39 26.91C24.24 21.42 29.82 18 36 18C43.86 18 50.64 23.58 52.17 31.29L53.07 35.79L57.66 36.12C62.34 36.42 66 40.35 66 45C66 49.95 61.95 54 57 54ZM31.65 39H24L36 27L48 39H40.35V48H31.65V39Z',
      },
    ],
    size: {
      height: 75,
      width: 75,
    },
    viewBox: '0 0 72 72',
    translate: {
      x: 0,
      y: 0,
    },
  },
  slider_background: {
    name: 'slider_background',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M55.3443 0C42.1904 0 43.691 28.0033 34.1943 36.5379C21.6255 47.8352 0 42.2423 0 61.6315C0 95.6686 28.0485 108 58.6163 108C89.184 108 115.263 89.1211 106.161 55.1752C97.0609 21.2259 85.9105 0 55.3443 0Z',
      },
    ],
    size: {
      height: 108,
      width: 108,
    },
    viewBox: '0 0 108 108',
    translate: {
      x: 0,
      y: 0,
    },
  },
  slider_background_mobile: {
    name: 'slider_background_mobile',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M114.276 0C87.1154 0 90.2139 55.4879 70.6049 72.3991C44.6527 94.7845 0 83.7023 0 122.122C0 189.566 57.915 214 121.032 214C184.149 214 237.997 176.592 219.203 109.329C200.413 42.0587 177.389 0 114.276 0Z',
      },
    ],
    size: {
      height: 120,
      width: 127,
    },
    viewBox: '0 0 127 120',
    translate: {
      x: 0,
      y: 0,
    },
  },
  plus_payka: {
    name: 'plus_payka',
    paths: [
      {
        fill: '#C49BBB',
        windingRule: 'evenodd',
        data: 'M14.4058 30C22.3619 30 28.8116 23.2843 28.8116 15C28.8116 6.71573 22.3619 0 14.4058 0C6.44969 0 0 6.71573 0 15C0 23.2843 6.44969 30 14.4058 30Z',
      },
      {
        fill: 'white',
        windingRule: 'evenodd',
        data: 'M12.131 16.192H9.26545C8.6895 16.192 8.22021 15.659 8.22021 15C8.22021 14.3411 8.6895 13.808 9.26545 13.808H12.131C12.7069 13.808 13.1762 13.275 13.1762 12.616V9.35839C13.1762 8.69945 13.6455 8.16638 14.2214 8.16638H14.5699C15.1458 8.16638 15.6151 8.69945 15.6151 9.35839V12.616C15.6151 13.275 16.0844 13.808 16.6603 13.808H19.5258C20.1018 13.808 20.5711 14.3411 20.5711 15C20.5711 15.659 20.1018 16.192 19.5258 16.192H16.6603C16.0844 16.192 15.6151 16.7251 15.6151 17.3841V20.6417C15.6151 21.3006 15.1458 21.8337 14.5699 21.8337H14.2214C13.6455 21.8337 13.1762 21.3006 13.1762 20.6417V17.3841C13.1762 16.7251 12.7069 16.192 12.131 16.192Z',
      },
    ],
    size: {
      height: 30,
      width: 29,
    },
    viewBox: '0 0 29 30',
    translate: {
      x: 0,
      y: 0,
    },
  },

  heart: {
    name: 'heart',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M9 4.18627C9.8175 3.22627 11.07 2.61877 12.375 2.61877C14.685 2.61877 16.5 4.43377 16.5 6.74377C16.5 9.57645 13.9542 11.885 10.097 15.3827L10.0875 15.3913L9 16.3813L7.9125 15.3988L7.88289 15.3719C4.03697 11.877 1.5 9.57152 1.5 6.74377C1.5 4.43377 3.315 2.61877 5.625 2.61877C6.93 2.61877 8.1825 3.22627 9 4.18627ZM9 14.3563L9.075 14.2813C12.645 11.0488 15 8.91127 15 6.74377C15 5.24377 13.875 4.11877 12.375 4.11877C11.22 4.11877 10.095 4.86127 9.705 5.88877H8.3025C7.905 4.86127 6.78 4.11877 5.625 4.11877C4.125 4.11877 3 5.24377 3 6.74377C3 8.91127 5.355 11.0488 8.925 14.2813L9 14.3563Z',
      },

    ],
    size: {
      height: 19,
      width: 18,
    },
    viewBox: '0 0 18 19',
    translate: {
      x: 0,
      y: 0,
    },
  },
  account_circle_24px: {
    name: 'account_circle_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.51 17.38 16.93 18.28C15.57 19.36 13.86 20 12 20C10.14 20 8.43 19.36 7.07 18.28ZM12 14.5C13.46 14.5 16.93 15.09 18.36 16.83C19.38 15.49 20 13.82 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12C4 13.82 4.62 15.49 5.64 16.83C7.07 15.09 10.54 14.5 12 14.5ZM12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM10.5 9.5C10.5 10.33 11.17 11 12 11C12.83 11 13.5 10.33 13.5 9.5C13.5 8.67 12.83 8 12 8C11.17 8 10.5 8.67 10.5 9.5Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  settings_24px: {
    name: 'settings_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M3 5L12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5ZM19 11.99H12V3.19L5 6.3V12H12V20.93C15.72 19.78 18.47 16.11 19 11.99Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  list_alt_24px: {
    name: 'list_alt_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM9 7H7V9H9V7ZM17 7H11V9H17V7ZM17 11H11V13H17V11ZM11 15H17V17H11V15ZM7 11H9V13H7V11ZM9 15H7V17H9V15ZM5 19H19V5H5V19Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  forum_24px: {
    name: 'forum_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM15 4V11H5.17L4 12.17V4H15ZM19 6H21C21.55 6 22 6.45 22 7V22L18 18H7C6.45 18 6 17.55 6 17V15H19V6Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  message_24px: {
    name: 'message_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM4 4H20V16H5.17L4 17.17V4ZM18 12H6V14H18V12ZM6 9H18V11H6V9ZM18 6H6V8H18V6Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  import_contacts_24px: {
    name: 'import_contacts_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M17.5 3.5C18.67 3.5 19.89 3.65 21 4C21.75 4.25 22.4 4.55 23 5V19.6C23 19.85 22.75 20.1 22.5 20.1C22.4 20.1 22.35 20.1 22.25 20.05C20.85 19.3 19.15 19 17.5 19C15.8 19 13.35 19.65 12 20.5C10.55 19.4 8.45 19 6.5 19C5.05 19 3.1 19.45 1.75 20.1C1.7 20.1 1.6625 20.1125 1.625 20.125C1.5875 20.1375 1.55 20.15 1.5 20.15C1.25 20.15 1 19.9 1 19.65V5C2.45 3.9 4.55 3.5 6.5 3.5C8.45 3.5 10.55 3.9 12 5C13.45 3.9 15.55 3.5 17.5 3.5ZM17.5 17C18.7 17 19.9 17.15 21 17.5V6C19.9 5.65 18.7 5.5 17.5 5.5C15.8 5.5 13.35 6.15 12 7V18.5C13.35 17.65 15.8 17 17.5 17Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  subtitles_24px: {
    name: 'subtitles_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4ZM4 18H20V6H4V18ZM6 10H8V12H6V10ZM14 14H6V16H14V14ZM16 14H18V16H16V14ZM18 10H10V12H18V10Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  playlist_add_check_24px: {
    name: 'playlist_add_check_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M1.5 5H13.5V7H1.5V5ZM1.5 9H13.5V11H1.5V9ZM1.5 15H9.5V13H1.5V15ZM22.5 12L21 10.5L15.51 16L12.5 13L11 14.5L15.51 19L22.5 12Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  security_24px: {
    name: 'security_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M3 5L12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5ZM19 11.99H12V3.19L5 6.3V12H12V20.93C15.72 19.78 18.47 16.11 19 11.99Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  do_disturb_alt_24px: {
    name: 'do_disturb_alt_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM4 12C4 7.6 7.6 4 12 4C13.8 4 15.5 4.6 16.9 5.7L5.7 16.9C4.6 15.5 4 13.8 4 12ZM7.1 18.3C8.5 19.4 10.2 20 12 20C16.4 20 20 16.4 20 12C20 10.2 19.4 8.5 18.3 7.1L7.1 18.3Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },

  check_circle_outline_24px: {
    name: 'check_circle_outline_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM10 14.17L16.59 7.58L18 9L10 17L6 13L7.41 11.59L10 14.17Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
  markunread_24px: {
    name: 'markunread_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M29.3334 8.00004C29.3334 6.53337 28.1334 5.33337 26.6667 5.33337H5.33335C3.86669 5.33337 2.66669 6.53337 2.66669 8.00004V24C2.66669 25.4667 3.86669 26.6667 5.33335 26.6667H26.6667C28.1334 26.6667 29.3334 25.4667 29.3334 24V8.00004ZM26.6667 8.00004L16 14.6667L5.33335 8.00004H26.6667ZM16 17.3334L5.33335 10.6667V24H26.6667V10.6667L16 17.3334Z',
      },
    ],
    size: {
      height: 32,
      width: 32,
    },
    viewBox: '0 0 32 32',
    translate: {
      x: 0,
      y: 0,
    },
  },
  phone_locked_24px: {
    name: 'phone_locked_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M26.6667 6.66666V5.99999C26.6667 4.15999 25.1733 2.66666 23.3333 2.66666C21.4933 2.66666 20 4.15999 20 5.99999V6.66666C19.2667 6.66666 18.6667 7.26666 18.6667 7.99999V13.3333C18.6667 14.0667 19.2667 14.6667 20 14.6667H26.6667C27.4 14.6667 28 14.0667 28 13.3333V7.99999C28 7.26666 27.4 6.66666 26.6667 6.66666ZM26.6667 22C25 22 23.4 21.7333 21.9067 21.24C21.7733 21.2 21.6267 21.1733 21.4933 21.1733C21.1467 21.1733 20.8133 21.3067 20.5467 21.56L17.6133 24.4933C13.84 22.5733 10.7467 19.4933 8.82667 15.7067L11.76 12.76C12.1333 12.4133 12.24 11.8933 12.0933 11.4267C11.6 9.93332 11.3333 8.33332 11.3333 6.66666C11.3333 5.93332 10.7333 5.33332 10 5.33332H5.33333C4.6 5.33332 4 5.93332 4 6.66666C4 19.1867 14.1467 29.3333 26.6667 29.3333C27.4 29.3333 28 28.7333 28 28V23.3333C28 22.6 27.4 22 26.6667 22ZM8.70667 7.99999C8.8 9.17332 9 10.3333 9.30667 11.44L7.70667 13.0533C7.17333 11.44 6.82667 9.75999 6.70667 7.99999H8.70667ZM20.2667 25.6133C21.8667 26.16 23.5733 26.5067 25.3333 26.6267V24.6133C24.16 24.5333 23 24.3333 21.8667 24.0133L20.2667 25.6133ZM21.3333 6.66666H25.3333V5.99999C25.3333 4.89332 24.44 3.99999 23.3333 3.99999C22.2267 3.99999 21.3333 4.89332 21.3333 5.99999V6.66666Z',
      },
    ],
    size: {
      height: 32,
      width: 32,
    },
    viewBox: '0 0 32 32',
    translate: {
      x: 0,
      y: 0,
    },
  },
  account_balance_wallet_outline: {
    name: 'account_balance_wallet_outline',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M27.3333 6.66667V9.70667C28.12 10.1733 28.6666 11.0133 28.6666 12V20C28.6666 20.9867 28.12 21.8267 27.3333 22.2933V25.3333C27.3333 26.8 26.1333 28 24.6666 28H5.99998C4.51998 28 3.33331 26.8 3.33331 25.3333V6.66667C3.33331 5.2 4.51998 4 5.99998 4H24.6666C26.1333 4 27.3333 5.2 27.3333 6.66667ZM16.6666 20H26V12H16.6666V20ZM5.99998 25.3333V6.66667H24.6666V9.33333H16.6666C15.2 9.33333 14 10.5333 14 12V20C14 21.4667 15.2 22.6667 16.6666 22.6667H24.6666V25.3333H5.99998ZM18.6666 16C18.6666 14.8954 19.5621 14 20.6666 14C21.7712 14 22.6666 14.8954 22.6666 16C22.6666 17.1046 21.7712 18 20.6666 18C19.5621 18 18.6666 17.1046 18.6666 16Z',
      },
    ],
    size: {
      height: 32,
      width: 32,
    },
    viewBox: '0 0 32 32',
    translate: {
      x: 0,
      y: 0,
    },
  },
  info_24px: {
    name: 'info_24px',
    paths: [
      {
        windingRule: 'evenodd',
        data: 'M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4ZM13 11V17H11V11H13ZM13 7V9H11V7H13Z',
      },
    ],
    size: {
      height: 24,
      width: 24,
    },
    viewBox: '0 0 24 24',
    translate: {
      x: 0,
      y: 0,
    },
  },
};
